// Пакет строк «ru» (E01-T11): ключи нарратива (UI-…, ERR-…, TUT-…) и черновые CL-… клиента на вычитку
// нарратива (E20-T25). Тексты ICU (ADR-0026). Перекрытия без релиза — clientConfig.values.strings.
export const STRINGS_RU = {
  "CL-COOP-TASK-Q-C-10": "Выполнить ежедневные «все 5»",
  "CL-COOP-TASK-Q-C-11": "Сыграть в домино или крутануть колесо",
  "CL-COOP-TASK-Q-C-12": "Зайти в гости к соседям по кооперативу",
  "CL-COOP-TASK-UNKNOWN": "Задание кооператива",
  "CL-CHAT-CONSENT": "Чат — для своих. Пишу по-соседски и принимаю правила чата: без мата, оскорблений, политики, рекламы и криминала.",
  "CL-CHAT-RULES-READ": "Правила чата",
  "CL-LEGAL-REFUNDS": "Политика возвратов",
  "CL-LEGAL-AGE": "Возрастная маркировка 18+",
  "CL-SET-HIDE-CHRONICLE-HINT": "В хронике и канале — только игровое имя, без имени и фото из Telegram",
  "CL-SET-CH-TRIP-DONE": "Машина вернулась",
  "CL-SET-CH-COOP-CALL": "Сбор на кооперативного босса",
  "CL-SET-CH-RAID-START": "Рейд начался",
  "CL-SET-CH-ENERGY-FULL": "Энергия полная",
  "CL-SET-CH-NEWS": "Новости игры",
  "TUT-T07-01": "Без верстака какой гараж? Подлатаем — с меня доски.",
  "TUT-T07-02": "Тапни по верстаку",
  "TUT-T07-03": "Зона даёт бонус навсегда. Первый уровень — бесплатно",
  "TUT-T07-04": "Улучшить",
  "TUT-T07-05": "Верстак, уровень 1",
  "TUT-T07-06": "Другое дело! Зоны гаража видят все соседи. Есть чем похвастаться.",
  "TUT-T07-R": "Верстак ждёт. Первый раз — даром, доски мои.",
  "TUT-T08-01": "Витина Ласточка! Глянем, что у неё под брезентом?",
  "TUT-T08-02": "Осмотр",
  "TUT-T08-03": "Красное — сломано. Начни с двигателя",
  "TUT-T08-04": "Починить",
  "TUT-T08-05": "Чихнула и завелась! Мотор переберём — поедет.",
  "TUT-T08-06": "Выезды откроются на {lvl}-м уровне",
  "TUT-T08-R": "Ласточка ждёт. Мотор сам себя не переберёт.",
  "TUT-T09-01": "Один в гараже не воин. Тут кооперативы ищут людей — выбирай.",
  "TUT-T09-02": "Выбери кооператив из списка",
  "TUT-T09-03": "Приглашение от «{coop}»",
  "TUT-T09-04": "Председатель — {chair}. Участников: {n}. Общий босс, стройка и чат",
  "TUT-T09-05": "Тебя {player} зовёт. Свои — это хорошо.",
  "TUT-T09-06": "Вступить",
  "TUT-T09-07": "Позже",
  "TUT-T09-08": "Ну всё, ты теперь свой. В чате поздоровайся — там соседи.",
  "TUT-T09-09": "Дело добровольное. Кооператив никуда не денется.",
  "TUT-T09-R": "Доска объявлений на месте. Без кооператива тут скучно.",
  "TUT-T10-01": "Каждый день — новые дела. Сделал — получил.",
  "TUT-T10-02": "Дела на сегодня",
  "TUT-T10-03": "А это первая посылка от Вити. Что в ней — видно сразу.",
  "TUT-T10-04": "Открыть",
  "TUT-T10-05": "Тут видно, что лежит внутри",
  "TUT-T10-06": "Забрать",
  "TUT-T10-11": "Дальше Витя шлёт посылку каждый день. Бесплатно.",
  "TUT-T10-07": "Ну всё, дальше сам. Я в 118-м — заходи на чай.",
  "TUT-T10-08": "Гараж твой!",
  "TUT-T10-09": "Энергия полная. Город, кооператив и ларёк открыты.",
  "TUT-T10-10": "В путь",
  "TUT-T10-R": "Посылка у ворот так и стоит. Она не сгорит, но открыть-то хочется.",
  "CL-TUTORIAL-NEXT": "Дальше",
  "CL-QUEST-FIRST-BOX": "Первая посылка",
  "CL-QUEST-INSIDE": "Что внутри",
  "CL-SET-SOUND": "Звук",
  "CL-SET-MUSIC": "Музыка",
  "CL-SET-SFX": "Звуки",
  "CL-SET-FEEL": "Ощущения",
  "CL-SET-SCREEN": "Экран",
  "CL-SET-TEXT": "Размер текста",
  "CL-SET-MOTION": "Меньше движения",
  "CL-SET-BATTERY": "Экономия батареи",
  "CL-SET-BATTERY-HINT": "Сцена — 30 кадров в секунду",
  "CL-SET-NOTIFY-GROUP": "Уведомления и реклама",
  "CL-SET-NOTIFY": "Сообщения от бота",
  "CL-SET-NOTIFY-HINT": "Машина вернулась, стройка готова, сбор на босса",
  "CL-SET-NOTIFY-DENIED": "Telegram не разрешил боту писать — можно включить позже",
  "CL-SET-ADS": "Показывать рекламу",
  "CL-SET-ADS-HINT": "Кнопки «Реклама +10 энергии» и «Ящик за рекламу»",
  "CL-SET-HIDE-CHRONICLE": "Не показывать меня в хронике",
  "CL-SET-HELP": "Помощь",
  "CL-SET-ACCOUNT": "Аккаунт",
  "CL-SET-SUPPORT": "Поддержка",
  "CL-SET-LEGAL": "Правила и документы",
  "CL-SET-ABOUT": "Версия клиента {build} · таблицы баланса {balance}",
  "CL-ACC-ID": "ID игрока — нажми, чтобы скопировать",
  "CL-ACC-EXPORT": "Мои данные",
  "CL-ACC-EXPORT-HINT": "Архив со всем, что игра о тебе хранит. Собирается до суток, не чаще раза в неделю",
  "CL-ACC-EXPORT-GO": "Запросить архив",
  "CL-ACC-EXPORT-QUEUED": "Архив собирается",
  "CL-ACC-EXPORT-WAIT": "Архив будет готов к {date}",
  "CL-ACC-EXPORT-SOON": "завтра",
  "CL-ACC-EXPORT-DOWNLOAD": "Скачать архив",
  "CL-ACC-EXPORT-LIMIT": "Архив можно запросить снова с {date}",
  "CL-ACC-DELETE": "Удалить аккаунт",
  "CL-ACC-DELETE-HINT": "Через 7 дней гараж, вещи, кооператив и покупки пропадут навсегда. Зайдёшь в игру раньше — удаление отменится",
  "CL-ACC-DELETE-TYPE": "Чтобы подтвердить, напиши {word}",
  "CL-ACC-DELETE-GO": "Удалить через 7 дней",
  "CL-ACC-DELETE-AT": "Аккаунт удалится {date}. Если передумаешь — отмени или просто зайди в игру",
  "CL-ACC-DELETE-CANCEL": "Отменить удаление",
  "CL-ACC-CANCELLED": "Удаление отменено",
  "CL-ACC-NOTHING": "Отменять нечего",
  "CL-ACC-PENDING-PAY": "Есть оплаченный, но не выданный заказ или возврат в работе. Удалить можно, когда он закроется",
  "CL-ACC-ALREADY": "Удаление уже назначено",
  "CL-SUP-WRITE": "Написать в поддержку",
  "CL-SUP-PAYSUPPORT": "По покупкам у бота есть команда /paysupport",
  "CL-FAQ-PURCHASE-Q": "Не пришла покупка",
  "CL-FAQ-PURCHASE-A": "Обычно звёзды доходят за минуту. Если талонов нет дольше 15 минут — напиши в поддержку и приложи номер заказа из «Покупок».",
  "CL-FAQ-ITEM-Q": "Пропал предмет",
  "CL-FAQ-ITEM-A": "Проверь сумку и фильтры. Разобранное и проданное не возвращается; если уверен, что ничего не делал, — напиши в поддержку.",
  "CL-FAQ-COOP-LEAVE-Q": "Как выйти из кооператива",
  "CL-FAQ-COOP-LEAVE-A": "Внизу главной кооператива — «Выйти из кооператива». Председателю сначала нужно передать пост. Вступить снова можно через 24 ч.",
  "CL-FAQ-ODDS-Q": "Как считаются шансы",
  "CL-FAQ-ODDS-A": "Шансы каждого ящика и награды показаны рядом с ним. Они одинаковы для всех и не зависят от покупок.",
  "CL-FAQ-ENERGY-Q": "Куда делась энергия",
  "CL-FAQ-ENERGY-A": "Энергия тратится на бои и наряды и восстанавливается сама: 1 единица за 3 минуты, до предела.",
  "CL-FAQ-TUTORIAL-Q": "Обучение застряло",
  "CL-FAQ-TUTORIAL-A": "Перезапусти игру — обучение продолжится с того же шага. Не помогло — напиши в поддержку.",
  "CL-FAQ-NAME-Q": "Как сменить имя",
  "CL-FAQ-NAME-A": "Имя берётся из Telegram. Смена имени в игре появится позже.",
  "CL-FAQ-DELETE-Q": "Как удалить аккаунт",
  "CL-FAQ-DELETE-A": "Настройки → Аккаунт → «Удалить аккаунт». Удаление наступает через 7 дней, до этого его можно отменить.",
  "CL-LEGAL-TERMS": "Правила игры",
  "CL-LEGAL-PRIVACY": "Политика данных",
  "CL-LEGAL-CHAT": "Правила чата",
  "CL-LEGAL-ODDS": "Как считаются шансы",
  "CL-LEGAL-ODDS-TEXT": "Шансы показаны у каждого ящика и награды",
  "CL-LEGAL-UPDATED": "Правила обновились",
  "CL-LEGAL-LOOK": "Посмотреть",
  "CL-LEGAL-NEW-VERSION": "новая редакция {v}",
  "CL-LEGAL-ACCEPT": "Принимаю",
  "CL-LEGAL-ACCEPTED": "Спасибо, принято",
  "CL-LEGAL-SOON": "текст появится позже",
  "CL-QUEST-Q-D-01": "Провести {nf} {n, plural, one {заход} few {захода} other {заходов}}",
  "CL-QUEST-Q-D-02": "Победить любого босса",
  "CL-QUEST-Q-D-03": "Использовать «Бросок ключа» {nf} {n, plural, one {раз} few {раза} other {раз}}",
  "CL-QUEST-Q-D-04": "Использовать «Химию» {nf} {n, plural, one {раз} few {раза} other {раз}}",
  "CL-QUEST-Q-D-05": "Нанести {nf} урона",
  "CL-QUEST-Q-D-06": "Потратить {nf} солярки",
  "CL-QUEST-Q-D-07": "Сделать зачётный заход в кооперативном инстансе",
  "CL-QUEST-Q-D-08": "Отменить телеграф «Домкратом»",
  "CL-QUEST-Q-D-09": "Сделать «Зачистку»",
  "CL-QUEST-Q-D-10": "Провести заход в D-районе своего уровня",
  "CL-QUEST-Q-D-11": "Улучшить любой предмет",
  "CL-QUEST-Q-D-12": "Начать стройку зоны гаража",
  "CL-QUEST-Q-D-13": "Разобрать {nf} {n, plural, one {предмет} few {предмета} other {предметов}}",
  "CL-QUEST-Q-D-14": "Продать {nf} {n, plural, one {предмет} few {предмета} other {предметов}}",
  "CL-QUEST-Q-D-15": "Отправить машину в выезд",
  "CL-QUEST-Q-D-16": "Забрать награду выезда",
  "CL-QUEST-Q-D-17": "Подлатать узел машины",
  "CL-QUEST-Q-D-18": "Надеть предмет лучше надетого",
  "CL-QUEST-Q-D-19": "Поставить уважение {nf} {n, plural, one {игроку} few {игрокам} other {игрокам}}",
  "CL-QUEST-Q-D-20": "Сдать в склад кооператива {nf} {n, plural, one {гайку} few {гайки} other {гаек}}",
  "CL-QUEST-Q-D-21": "Зайти в гости в гараж соседа",
  "CL-QUEST-Q-D-22": "Написать в чат кооператива",
  "CL-QUEST-Q-D-23": "Выполнить наряд кооператива",
  "CL-QUEST-Q-D-24": "Крутануть колесо",
  "CL-QUEST-Q-D-25": "Сыграть партию в домино",
  "CL-QUEST-Q-D-26": "Сыграть партию в домино «С соседом» или «Двор»",
  "CL-QUEST-Q-W-01": "Победить {nf} {n, plural, one {босса} few {боссов} other {боссов}}",
  "CL-QUEST-Q-W-02": "Стать «участником» мирового рейда W01",
  "CL-QUEST-Q-W-03": "Нанести {nf} урона за неделю",
  "CL-QUEST-Q-W-04": "Выполнить ежедневные «все 5» {nf} {n, plural, one {день} few {дня} other {дней}}",
  "CL-QUEST-Q-W-05": "Завершить {nf} {n, plural, one {выезд} few {выезда} other {выездов}}",
  "CL-QUEST-Q-W-06": "Поднять уровень любой зоны гаража",
  "CL-QUEST-Q-W-07": "Улучшить предметы суммарно на {nf} {n, plural, one {ступень} few {ступени} other {ступеней}}",
  "CL-QUEST-Q-W-08": "Набрать {nf} {n, plural, one {очко} few {очка} other {очков}} Собрания",
  "CL-QUEST-Q-W-09": "Собрать 2 разных предмета одного сета",
  "CL-QUEST-Q-W-10": "Сыграть {nf} {n, plural, one {партию} few {партии} other {партий}} в домино",
  "CL-QUEST-Q-W-11": "Победить в одиночку босса района, открытого лично",
  "CL-QUEST-Q-W-12": "Получить {nf} уважения",
  "CL-QUEST-Q-W-13": "Победить в одиночку звезду сезона {nf} {n, plural, one {раз} few {раза} other {раз}}",
  "CL-ACH-A-01": "Боец района",
  "CL-ACH-A-02": "Хозяин гаража",
  "CL-ACH-A-03": "Механик",
  "CL-ACH-A-04": "Дальний рейс",
  "CL-ACH-A-05": "Коллекционер",
  "CL-ACH-A-06": "Первый у Прожоры",
  "CL-ACH-A-07": "Свой в кооперативе",
  "CL-ACH-A-08": "Уважаемый человек",
  "CL-ACH-A-09": "Доминошник",
  "CL-ACH-A-10": "Вклад в общее дело",
  "CL-ACH-A-11": "Районы",
  "CL-ACH-A-12": "Друзья по гаражу",
  "CL-ACH-A-13": "Телеграфист",
  "CL-ACH-A-14": "Без единой царапины",
  "CL-ACH-A-15": "Мастер на все руки",
  "CL-ACH-A-16": "Топ недели",
  "CL-ACH-A-17": "Собрание",
  "CL-ACH-A-18": "Сезонник",
  "CL-ACH-A-19": "Растёшь",
  "CL-ACH-A-20": "Первая победа",
  "UI-NAV-QUESTS": "Задания",
  "CL-QUEST-NEW-DAY": "Новый день через {time}",
  "CL-QUEST-NEW-DAY-BANNER": "Новый день! Задания обновились",
  "CL-QUEST-REFRESH": "Обновить",
  "CL-QUEST-BOX": "Посылка от дяди Вити",
  "CL-QUEST-BOX-HINT": "Бесплатно, раз в день",
  "CL-QUEST-BOX-NEXT": "Открыта · следующая через {time}",
  "CL-QUEST-OPEN": "Открыть",
  "CL-QUEST-OPENED": "Открыта",
  "CL-QUEST-TAB-DAY": "День",
  "CL-QUEST-TAB-WEEK": "Неделя",
  "CL-QUEST-TAB-WEEK-LOCKED": "Неделя — с {n}-го уровня",
  "CL-QUEST-TAB-ACH": "Достижения",
  "CL-QUEST-WHAT": "Задания не загрузились. Прогресс на месте",
  "CL-QUEST-ALL": "За все {n}",
  "CL-QUEST-OF": "{k} из {n}",
  "CL-QUEST-CLAIM": "Забрать",
  "CL-QUEST-CLAIM-ALL": "Забрать всё ({n})",
  "CL-QUEST-GO": "Идти",
  "CL-QUEST-GOT": "Получено: {what}",
  "CL-QUEST-GOT-ALL": "Забрано наград: {n}",
  "CL-QUEST-NOT-DONE": "Ещё не выполнено: {progress} / {target}",
  "CL-QUEST-EMPTY": "Заданий пока нет",
  "CL-QUEST-DONE-TODAY": "На сегодня всё. Новые задания в 04:00",
  "CL-QUEST-DONE-N": "Выполнено: {n}",
  "CL-QUEST-TO-MAIL": "Не забрали — придёт в почту",
  "CL-QUEST-UNKNOWN": "Задание",
  "CL-QUEST-ITEM": "предмет",
  "CL-ITEM-BOX-IRON": "Железный ящик",
  "CL-ACH-TIER": "ступень {k} из {n}",
  "CL-MAIL-TITLE": "Почта",
  "CL-MAIL-EMPTY": "Писем пока нет",
  "CL-MAIL-UNTITLED": "Письмо",
  "CL-MAIL-FROM-UNCLE": "Дядя Витя",
  "CL-MAIL-FROM-COOP": "Правление кооператива",
  "CL-MAIL-FROM-SEMYONYCH": "Семёныч",
  "CL-MAIL-FROM-ADMIN": "Администрация игры",
  "CL-MAIL-LEFT": "ещё {time}",
  "CL-MAIL-DAYS": "{n, plural, one {# день} few {# дня} other {# дней}}",
  "CL-MAIL-CLAIM": "Забрать",
  "CL-MAIL-CLAIM-ALL": "Забрать всё ({n})",
  "CL-MAIL-GOT": "Забрано",
  "CL-MAIL-GOT-ALL": "Забрано из писем: {n}",
  "CL-MAIL-ALREADY": "Уже забрано",
  "CL-MAIL-EXPIRED": "Срок письма вышел — вложение не забрать",
  "CL-MAIL-ATTACH": "Вложение",
  "CL-MAIL-CLAIMED": "Забрано",
  "MAIL-CTG-SUBJECT": "Талоны на старт закрытого теста",
  "MAIL-CTG-BODY": "Люба передала {n} талонов: оплаты на тесте нет, а ларёк попробовать надо. Это подарок, не покупка — назад не забирается.",
  "MAIL-UNCLE-1": "Письмо от дяди Вити",
  "MAIL-UNCLE-1-BODY": "Племяш, гараж теперь твой. Береги Ласточку, не ругайся с соседями и заходи в кооператив — вместе веселее. Вложил тебе на первое время.",
  "MAIL-COOP-BOARD-DONE": "Доска объявлений: общее задание выполнено",
  "MAIL-COOP-BOARD-DONE-BODY": "Кооператив выполнил общее задание дня. Твоя доля — во вложении.",
  "MAIL-COOP-BOSS-POT": "Кооперативный босс побеждён",
  "MAIL-COOP-BOSS-POT-BODY": "Котёл инстанса поделён. Твоя доля уже начислена.",
  "MAIL-COOP-BOSS-PARTICIPATION": "Кооперативный бой окончен",
  "MAIL-COOP-BOSS-PARTICIPATION-BODY": "Босс ушёл, но за участие тебе положено. Уже начислено.",
  "COOP-ROLE-DENIED": "Это может только председатель или заместитель",
  "CL-COOP-WITHDRAW": "Отозвать",
  "CL-COOP-WITHDRAW-REQ": "Отозвать заявку",
  "CL-COOP-WITHDRAWN": "Заявка отозвана",
  "CL-COOP-WEEK-PTS": "за неделю {n}",
  "CL-COOP-ONLINE": "онлайн",
  "CL-COOP-SEEN-MIN": "был {n} мин назад",
  "CL-COOP-SEEN-H": "был {n} ч назад",
  "CL-COOP-SEEN-D": "был {n} дн. назад",
  "CL-COOP-SEEN-LONG": "давно не заходил",
  "CL-COOP-SAVE": "Сохранить",
  "CL-COOP-SAVED": "Сохранено",
  "CL-COOP-RENAME-NEXT": "Следующее переименование: {date}",
  "CL-COOP-RENAME-COST": "Переименование — раз в 30 дней, {cost}",
  "CL-COOP-RENAME-Q": "Переименовать в «{name}» за {cost}? Следующий раз — через 30 дней",
  "CL-COOP-PINNED": "Закреплённое сообщение",
  "CL-COOP-EMBLEM-COST": "Эмблему сменишь в конструкторе, когда он появится: {cost}",
  "CL-CHAT-PIN": "Закрепить",
  "CL-CHAT-PINNED": "Сообщение закреплено",
  "COOP-CHAT-EMPTY": "Тихо. Даже Аркадич не сверлит. Напиши первым.",
  "COOP-CHAT-PLACEHOLDER": "Сообщение соседям…",
  "COOP-CHAT-RULES": "По-соседски: без мата, оскорблений, политики и криминала.",
  "CL-CHAT-LOAD-FAIL": "Чат не загрузился",
  "CL-CHAT-RETRY": "Повторить",
  "CL-CHAT-OLDER": "Листай вверх — там раньше",
  "CL-CHAT-NEW": "↓ {n} новых",
  "CL-CHAT-HIDDEN": "Сообщение скрыто",
  "CL-CHAT-SHOW": "Показать",
  "CL-CHAT-HIDDEN-FILTER": "Скрыто фильтром — видишь только ты",
  "CL-CHAT-HIDDEN-MOD": "Скрыто модератором — видишь только ты",
  "CL-CHAT-DELETED": "Удалено",
  "CL-CHAT-REPLY-TO": "Ответ {name}",
  "CL-CHAT-MUTED": "Писать нельзя до {time}",
  "CL-CHAT-QUICK": "Быстрые реплики",
  "CL-CHAT-QUICK-1": "Всем привет!",
  "CL-CHAT-QUICK-2": "Кто на босса?",
  "CL-CHAT-QUICK-3": "Сдал в копилку",
  "CL-CHAT-QUICK-4": "Иду в бой",
  "CL-CHAT-QUICK-5": "Спасибо, соседи!",
  "CL-CHAT-QUICK-6": "До вечера",
  "CL-CHAT-SEND": "Отправить",
  "CL-CHAT-REJECTED": "Так писать нельзя",
  "CL-CHAT-OFFLINE": "Нет связи — отправим, когда появится",
  "CL-CHAT-FAILED": "Сообщение не ушло",
  "CL-CHAT-DELETE": "Удалить",
  "CL-CHAT-REPLY": "Ответить",
  "CL-CHAT-COPY": "Копировать",
  "CL-CHAT-COPIED": "Скопировано",
  "CL-CHAT-MUTE-1H": "Заглушить на 1 ч",
  "CL-CHAT-MUTE-24H": "Заглушить на 24 ч",
  "CL-CHAT-MUTE-DONE": "{name} помолчит",
  "CL-CHAT-REPORTED": "Жалоба отправлена",
  "CL-CHAT-ALREADY-REPORTED": "Жалоба уже у модератора",
  "CL-CHAT-REASON-OFFENSIVE": "Оскорбления",
  "CL-CHAT-REASON-SPAM": "Спам",
  "CL-CHAT-REASON-SCAM": "Реклама или обман",
  "CL-CHAT-REASON-OTHER": "Другое",
  "CL-TG-TITLE": "Своя группа в Telegram",
  "CL-TG-LINK-ROW": "Привязать группу в Telegram",
  "CL-TG-STEP-1": "В Telegram: «Новая группа»",
  "CL-TG-STEP-2": "Настройки группы → Пригласительные ссылки → Копировать",
  "CL-TG-STEP-3": "Вернись сюда и вставь ссылку",
  "CL-TG-PASTE": "Вставить",
  "CL-TG-PASTE-HINT": "Нажми и удерживай поле → Вставить",
  "CL-TG-BAD-LINK": "Это не похоже на ссылку-приглашение",
  "CL-TG-URL-INVALID": "Это не ссылка-приглашение в группу",
  "CL-TG-FORBIDDEN": "Привязать группу может председатель или заместитель",
  "CL-TG-BIND": "Привязать",
  "CL-TG-CLEAR": "Очистить",
  "CL-TG-HOW": "Как создать группу",
  "CL-TG-LINKED": "Группа привязана",
  "CL-TG-OPEN": "Открыть группу",
  "CL-TG-REPLACE": "Заменить ссылку",
  "CL-TG-UNLINK": "Отвязать",
  "CL-TG-UNLINK-Q": "Отвязать группу? Участники перестанут её видеть",
  "CL-TG-UNLINKED": "Группа отвязана",
  "CL-TG-NOT-MODERATED": "Группа — твоя: игра её не модерирует. Правила Telegram действуют",
  "UI-NAV-COOP": "Кооператив",
  "COOP-NONE": "Ты пока сам по себе. Один гараж — сарай, много — сила.",
  "COOP-BTN-FIND": "Найти кооператив",
  "COOP-BTN-CREATE": "Создать свой",
  "COOP-CREATE-NAME": "Название кооператива",
  "COOP-CREATE-HINT": "3–20 знаков. Без грубостей, политики и криминала.",
  "COOP-OPEN": "Вход свободный",
  "COOP-BY-REQUEST": "Вход по заявке",
  "COOP-BTN-JOIN": "Вступить",
  "COOP-BTN-REQUEST": "Подать заявку",
  "COOP-REQUEST-SENT": "Заявка у правления. Ждём решения.",
  "COOP-FULL": "Мест нет: {n} из {n}",
  "COOP-MEMBERS": "Участники: {n} из {max}",
  "COOP-BTN-LEAVE": "Выйти",
  "COOP-ROLE-CHAIR": "Председатель",
  "COOP-ROLE-DEPUTY": "Заместитель",
  "COOP-ROLE-MEMBER": "Участник",
  "COOP-PROMOTE": "Сделать замом",
  "COOP-DEMOTE": "Снять зама",
  "COOP-TRANSFER": "Передать пост",
  "COOP-TRANSFER-CONFIRM": "Передать председательство {player}? Отменить нельзя.",
  "COOP-KICK": "Исключить",
  "COOP-BUILD-TITLE": "Общая стройка",
  "COOP-BUILD-LEVEL": "Уровень кооператива {lvl}: {cur} из {need} очков",
  "COOP-BUILD-DONATE": "Скинуться",
  "COOP-BUILD-PLAN": "Планов на постройки: {n}",
  "COOP-BUILD-PLAN-USE": "Потратить план на «{build}»? Переложить его потом нельзя.",
  "COOP-BUILD-UP": "«{build}» теперь {lvl}-го уровня. Бонус для всех.",
  "COOP-STORE": "Общая копилка",
  "COOP-STORE-NOTE": "Сданное идёт в стройку. Обратно копилка не выдаёт.",
  "COOP-ORDERS": "Наряды",
  "COOP-LAVKA": "Лавка кооператива",
  "COOP-LAVKA-NOTE": "Здесь платят отметками из ведомости.",
  "COOP-CHAT-TITLE": "Разговоры у ворот",
  "COOP-TG-LINK": "Группа «{coop}»",
  "CL-COOP-NONE-TITLE": "Один в гараже не воин",
  "CL-COOP-WHY-1": "Постройки дают бонусы всем соседям",
  "CL-COOP-WHY-2": "Кооперативного босса бьют всем рядом",
  "CL-COOP-WHY-3": "Раз в неделю — «Собрание кооперативов»",
  "CL-COOP-INVITES": "Тебя зовут",
  "CL-COOP-INVITED-BY": "Зовёт {name}",
  "CL-COOP-MY-REQUESTS": "Мои заявки",
  "CL-COOP-REQ-WAIT": "Заявка в «{name}» — ждёт, ещё {time}",
  "CL-COOP-RECOMMENDED": "Рядом есть места",
  "CL-COOP-NO-RECOMMEND": "Подходящих пока нет — найди вручную",
  "CL-COOP-WHAT": "Кооперативы",
  "CL-COOP-COOLDOWN": "Вступить можно через {time}",
  "CL-COOP-CREATE-LOCKED": "Свой кооператив — с {n}-го уровня",
  "CL-COOP-LVL": "ур. {n}",
  "CL-COOP-MIN-LVL": "мин. уровень {n}",
  "CL-COOP-INVITE-ONLY": "Только по приглашению",
  "CL-COOP-DORMANT": "засыпает",
  "CL-COOP-NPC": "соседский",
  "CL-COOP-NPC-NOTE": "Председатель — Семёныч. Когда кто-то из вас дойдёт до 10-го уровня, председателем станет самый активный",
  "CL-COOP-SEARCH-PH": "Название кооператива",
  "CL-COOP-SEARCH-FAIL": "Поиск не сработал. Попробуй ещё раз",
  "CL-COOP-F-OPEN": "Открытый приём",
  "CL-COOP-F-SLOTS": "Есть места",
  "CL-COOP-F-LEVEL": "Мой уровень подходит",
  "CL-COOP-NOTHING": "Ничего не нашли",
  "CL-COOP-MORE": "Показать ещё",
  "CL-COOP-GONE": "Кооператив закрылся",
  "CL-COOP-OPEN": "Открыть",
  "CL-COOP-ACCEPT-INVITE": "Принять приглашение",
  "CL-COOP-DECLINE": "Отклонить",
  "CL-COOP-ACCEPT": "Принять",
  "CL-COOP-MOVE-HERE": "Перейти сюда",
  "CL-COOP-JOIN-IN": "Вступить через {time}",
  "CL-COOP-NEED-LVL": "Нужен {n} уровень",
  "CL-COOP-NO-SLOTS": "Мест нет",
  "CL-COOP-REQ-SENT-BTN": "Заявка отправлена",
  "CL-COOP-REQ-LIMIT": "Уже 5 заявок",
  "CL-COOP-SEND": "Отправить",
  "CL-COOP-REQ-MSG": "Пару слов председателю (необязательно)",
  "CL-COOP-REQ-NOTE": "Если примут, остальные заявки отменятся",
  "CL-COOP-BAD-TEXT": "Так писать нельзя",
  "CL-COOP-FULL-NOW": "Мест уже нет",
  "CL-COOP-NOW-REQUEST": "Теперь только по заявке",
  "CL-COOP-ACTIVE-7D": "Заходили за неделю: {n}",
  "CL-COOP-HAS-TG": "есть группа в Telegram",
  "CL-COOP-DESC": "Описание",
  "CL-COOP-JOIN-MODE": "Приём",
  "CL-COOP-NAME-SHORT": "Слишком короткое",
  "CL-COOP-NAME-LONG": "Не длиннее 20 знаков",
  "CL-COOP-NAME-CHARS": "Только буквы, цифры и пробел",
  "CL-COOP-NAME-BAD": "Такое название нельзя",
  "CL-COOP-NAME-TAKEN": "Название занято",
  "CL-COOP-NAME-FREE": "Название свободно",
  "CL-COOP-EMBLEM-SOON": "Эмблему соберёшь, когда появится конструктор эмблем",
  "CL-COOP-CREATE-FOR": "Создать за {cost}",
  "CL-COOP-NEED-NUTS": "Не хватает {n} гаек",
  "CL-COOP-CREATED": "Кооператив создан. Позови соседей",
  "CL-COOP-LEAVE-FORM": "Выйти без сохранения?",
  "CL-COOP-LEAVE-FORM-GO": "Выйти",
  "CL-COOP-LEAVE-FORM-STAY": "Остаться",
  "CL-COOP-SETTINGS": "Настройки",
  "CL-COOP-MAX-LVL": "Кооператив на высшем уровне",
  "CL-COOP-FROZEN": "Кооператив заморожен модерацией. Бои и копилка работают",
  "CL-COOP-DORMANT-BANNER": "Кооператив засыпает: за неделю пришло {n}",
  "CL-COOP-NEW-REQUESTS": "Новых заявок: {n}",
  "CL-COOP-STORE-PTS": "Очки стройки: {n}",
  "CL-COOP-SUMMONS": "Объявлений о сборе: {n}",
  "CL-COOP-MARKS": "Отметки: {n} из {cap}",
  "CL-COOP-MEMBERS-TITLE": "Участники",
  "CL-COOP-ALL": "Все {n}",
  "CL-COOP-SOON": "скоро",
  "CL-COOP-INVITE": "Позвать в кооператив",
  "CL-COOP-SHARE-TEXT": "Заходи к нам в кооператив «{name}» в «Гаражах»",
  "CL-COOP-LEAVE": "Выйти из кооператива",
  "CL-COOP-DISBAND-PENDING": "Кооператив будет распущен через {time}",
  "CL-COOP-VOTE-TALLY": "Против: {k} из {need} нужных",
  "CL-COOP-VOTE-NO-DEPUTIES": "Заместителей нет — роспуск без голосования",
  "CL-COOP-VOTE-AGAINST": "Против роспуска",
  "CL-COOP-VOTE-CANCEL": "Отменить роспуск",
  "CL-COOP-BOARD": "Доска объявлений",
  "CL-COOP-BOARD-RESET": "до обновления {time}",
  "CL-COOP-BOARD-DONE": "Выполнено · награда в почте",
  "CL-COOP-PROGRESS": "{progress} / {target}",
  "CL-COOP-MY-STEPS": "мои шаги: {n} ✓",
  "CL-COOP-GO": "Идти",
  "CL-COOP-TENURE": "Шаги засчитаются через сутки",
  "CL-COOP-TASK-Q-C-01": "Провести заходы по любым боссам",
  "CL-COOP-TASK-Q-C-02": "Победить боссов в одиночку",
  "CL-COOP-TASK-Q-C-03": "Зачётные заходы в кооперативном бою",
  "CL-COOP-TASK-Q-C-04": "Победить кооперативного босса",
  "CL-COOP-TASK-Q-C-05": "Зачётные заходы по Прожоре",
  "CL-COOP-TASK-Q-C-06": "Сдать в копилку очки стройки",
  "CL-COOP-TASK-Q-C-07": "Выполнить наряды",
  "CL-COOP-TASK-Q-C-08": "Завершить выезды",
  "CL-COOP-TASK-Q-C-09": "Улучшить предметы на ступень",
  "CL-COOP-CHORES-LEFT": "осталось сегодня: {n}",
  "CL-COOP-CHORE-BUILD-SHIFT": "Смена на стройке",
  "CL-COOP-CHORE-CLEAR-RUBBLE": "Разбор завала",
  "CL-COOP-CHORE-GATE-DUTY": "Дежурство у шлагбаума",
  "CL-COOP-CHORE-DONE": "Наряд сдан: {what}, кооперативу +{pts} очков",
  "CL-COOP-CHORE-TENURE": "Наряды — после суток в кооперативе",
  "CL-COOP-MEMBERS-SUM": "{n} / {max} · заместителей {d} из {dmax}",
  "CL-COOP-MEMBER-SEARCH": "Имя участника",
  "CL-COOP-NEWBIE": "новенький",
  "CL-COOP-KICK-PENDING": "исключается через {time}",
  "CL-COOP-KICK-CANCEL": "Не исключать",
  "CL-COOP-KICK-CONFIRM": "Исключить {name}? Подать заявку сюда он сможет через 72 часа",
  "CL-COOP-KICK-LIMIT": "На сегодня исключений хватит: не больше 3 в сутки",
  "CL-COOP-TRANSFER-NOTE": "Ты станешь заместителем, если есть место, иначе участником. Следующая передача — через 7 дней",
  "CL-COOP-ELECTION-LOCK": "Пока идут перевыборы, исключать и менять роли нельзя",
  "CL-COOP-FROZEN-LOCK": "Руководство заморожено поддержкой",
  "CL-COOP-DEPUTY-LOCK": "Идёт голосование о роспуске — заместителя не тронуть",
  "CL-COOP-REQUESTS": "Заявки",
  "CL-COOP-NO-REQUESTS": "Новых заявок нет",
  "CL-COOP-REQ-LEFT": "осталось {time}",
  "CL-COOP-REQ-GONE": "Заявки уже нет: отозвал или вступил в другой",
  "CL-COOP-DECLINED": "Отклонено",
  "CL-COOP-ACCEPT-ALL": "Принять всех ({n})",
  "CL-COOP-SLOTS-REQS": "Мест: {free}, заявок: {n}",
  "CL-COOP-DISBAND": "Распустить",
  "CL-COOP-LEAVE-TITLE": "Выход из кооператива",
  "CL-COOP-LEAVE-TEXT": "Выйти из «{name}»? Сданное в склад и очки Собрания останутся кооперативу. Вступить куда-то снова можно через 24 ч",
  "CL-COOP-LEAVE-DORMANT": "Кооператив засыпает — выйти можно сразу, без 24 ч ожидания",
  "CL-COOP-MOVE-TEXT": "Выйти из «{old}» и вступить в «{name}»? Вступить сразу не получится: 24 ч перерыва",
  "CL-COOP-STAY": "Остаться",
  "CL-COOP-TRANSFER-FIRST": "Сначала передай председательство",
  "CL-COOP-PICK-SUCCESSOR": "Выбрать преемника",
  "CL-COOP-CANCEL": "Отмена",
  "CL-COOP-OK": "Понятно",
  "CL-COOP-DISBAND-ASSEMBLY": "Распустить нельзя до воскресенья 12:00 — пострадают награды участников",
  "CL-COOP-DISBAND-48": "Роспуск через 48 часов. Все получат уведомление, отменить можно в любой момент. Склад и постройки исчезнут",
  "CL-COOP-DISBAND-NOW": "Распустить кооператив сейчас? Название будет занято ещё 30 дней",
  "CL-COOP-DISBAND-VOTE-NOTE": "Заместители голосуют 48 ч. Если {need} из {n} против — роспуска не будет",
  "CL-COOP-DISBAND-48-BTN": "Распустить через 48 ч",
  "CL-COOP-TYPE-NAME": "Введи название «{name}», чтобы подтвердить",
  "CL-COOP-DISBAND-COOLDOWN": "Новый роспуск — не раньше чем через сутки после отмены",
  "CL-COOP-LEAVE-ELECTION": "Пока идут перевыборы, распускать и передавать роль нельзя",
  "CL-COOP-VOTE-TITLE": "Роспуск кооператива",
  "CL-COOP-VOTE-BY": "{name} распускает кооператив",
  "CL-COOP-VOTE-ENDS": "роспуск через {time}",
  "CL-COOP-VOTE-RULE": "Если {need} из {n} заместителей против — роспуска не будет. Промолчишь — значит, согласен",
  "CL-COOP-VOTE-LOSS": "Склад и постройки пропадут, название займут на 30 дней",
  "CL-COOP-VOTE-NOT": "Не против",
  "CL-COOP-VOTE-MY-AGAINST": "Ты против. Передумать можно до {until}",
  "CL-COOP-VOTE-MY-NOT": "Ты не против. Передумать можно до {until}",
  "CL-COOP-VOTE-CHANGE-NOT": "Уже не против",
  "CL-COOP-VOTE-CHAIR": "Заместители голосуют. Отменить роспуск можно в любой момент",
  "CL-COOP-VOTE-MEMBER": "Решают заместители. Большинство против — роспуска не будет",
  "CL-COOP-VOTE-SAVED": "Голос учтён",
  "CL-COOP-VOTE-CANCELLED": "Заместители против — роспуска не будет",
  "CL-COOP-VOTE-CANCELLED-CHAIR": "Председатель передумал — роспуска не будет",
  "CL-COOP-VOTE-CLOSING": "Голоса подсчитаны. Роспуск — через минуту",
  "CL-COOP-VOTE-GONE": "Роспуска уже нет",
  "CL-COOP-DONATE": "Сдать в склад",
  "CL-COOP-GIVE": "Сдать",
  "CL-COOP-SPARE": "Всё лишнее",
  "CL-COOP-SPARE-NOTE": "оставим {n} на ближайшее улучшение",
  "CL-COOP-DONATE-PTS": "В очки стройки: {n}",
  "CL-COOP-CAP-LEFT": "Зачтётся сегодня ещё {n} очков",
  "CL-COOP-CAP-DONE": "Сегодня в очки — 10% сданного; предел обновится в 04:00",
  "CL-COOP-OVER-CAP": "Сверх предела в очки идёт 10% — сданное всё равно уйдёт на склад",
  "CL-COOP-COUNTED": "Зачтено: {n} очков стройки",
  "CL-COOP-STORAGE-FULL": "Склад полон: нужен следующий уровень",
  "CL-COOP-BUILD-GO": "Строить",
  "CL-COOP-NO-PLANS": "Планов на постройки нет",
  "CL-COOP-NEED-COOP-LVL": "нужен {n} уровень кооператива",
  "CL-COOP-BLD-SHOP": "Мастерская кооператива",
  "CL-COOP-BLD-GUARD": "Сторожка",
  "CL-COOP-BLD-CORNER": "Комната отдыха",
  "CL-COOP-BLD-BOARD": "Доска объявлений",
  "CL-COOP-BLD-BOILER": "Котельная",
  "CL-COOP-BLD-YARD": "Двор с лавками",
  "CL-COOP-BLD-GATE": "Шлагбаум с вывеской",
  "CL-COOP-STORE-SPEND": "Тратится на постройки, объявления о сборе и вызов босса",
  "CL-COOP-LOG-ALL": "Все",
  "CL-COOP-LOG-MINE": "Мои",
  "CL-COOP-STORE-EMPTY": "Склад пуст. Сдай первые гайки",
  "CL-COOP-PTS": "{n} очков",
  "CL-COOP-MARKS-CAP": "Отметок {cap} из {cap}: потрать, иначе новые не начислятся",
  "CL-COOP-PRICE-MARKS": "{n} отметок",
  "CL-COOP-SHOP-LIMIT": "На этой неделе: {k} из {limit}",
  "CL-COOP-SHOP-MONDAY": "Снова в понедельник 04:00",
  "CL-COOP-SHOP-BUY": "Купить за {n} отметок",
  "CL-COOP-SHOP-NO-MARKS": "Не хватает {n} отметок",
  "CL-COOP-SHOP-WEEKLY": "Недельный предел исчерпан. Снова в понедельник 04:00",
  "CL-COOP-MARKS-PERSONAL": "Отметки личные: не передаются и остаются при выходе из кооператива",
  "CL-MAP-OFFLINE": "Карта на {p0} — нет связи",
  "CL-MAP-LOCK-BOSS": "сначала разберись с: {boss}",
  "CL-MAP-LOCK-LEVEL": "с {n}-го уровня",
  "CL-MAP-TOKEN-LOCKED": ", откроется на {n} уровне",
  "CL-MAP-TOKEN-LVL": "ур. {n}",
  "CL-GARAGE-RES": "Гараж",
  "CL-GARAGE-NUTS": "Гайки",
  "CL-GARAGE-READY": "Готово",
  "CL-GARAGE-LVL": "ур. {n}",
  "CL-GARAGE-NEW": "не построено",
  "CL-GARAGE-CANCEL-TITLE": "Отменить стройку?",
  "CL-GARAGE-CANCEL-TEXT": "Гайки вернутся полностью",
  "CL-GARAGE-CANCEL": "Отменить стройку",
  "CL-GARAGE-KEEP": "Строить дальше",
  "CL-GARAGE-REFUNDED": "Вернули {n} гаек",
  "CL-GARAGE-OFFLINE": "Нет связи",
  "CL-GARAGE-SPEEDUP": "Ускорить за талоны",
  "CL-GARAGE-OTHER": "К той стройке",
  "CL-GARAGE-NEED-LEVEL": "Нужен {n} уровень",
  "CL-GARAGE-LACK": "Не хватает {n} гаек",
  "CL-GARAGE-NO-BONUS": "Бонус появится с первым уровнем",
  "CL-GARAGE-NEXT": "Дальше: {stage}",
  "CL-GARAGE-BUILDING": "Стройка, ещё {t}",
  "CL-GARAGE-TIME": "Стройка {d}",
  "CL-GARAGE-INSTANT": "Сразу, без ожидания",
  "CL-GARAGE-CANCEL-LATE": "Отменить можно было в первые 5 минут",
  "CL-GARAGE-GREAT": "Отлично",
  "CL-CAR-BAD": "Плохо",
  "CL-CAR-SO-SO": "Так себе",
  "CL-CAR-OK": "Хорошо",
  "CL-CAR-PRICE-CHANGED": "Цена изменилась: {n} гаек. Нажми ещё раз",
  "CL-CAR-LVL": "ур. {n} / {max}",
  "CL-CAR-IN-TRIP-ROW": "Машина в пути",
  "CL-CAR-CLAIM": "Забрать добычу",
  "CL-CAR-RUNNING": "В пути · {t}",
  "CL-CAR-TRIPS": "Выезды",
  "CL-CAR-WHAT": "Машина",
  "CL-CAR-GONE": "Уехала: {route}. Вернётся в {time} МСК",
  "CL-CAR-TRIPS-LOCKED": "Выезды откроются на 4-м уровне",
  "CL-CAR-PATCH-FIRST": "Сначала подлатай",
  "CL-CAR-UPGRADE": "Улучшить за {cost}",
  "CL-CAR-NODE-LVL": "ур. {from} → {to}: {stage}",
  "CL-CAR-UP-COST": "Улучшение: {nuts} гаек и {scrap} лома",
  "CL-CAR-TO-CAR": "К машине",
  "CL-CAR-ROUTES-WHAT": "Маршруты",
  "CL-CAR-HOME": "Ласточка в гараже",
  "CL-CAR-RETURNS-IN": "Вернётся через {t}",
  "CL-CAR-ROUTE-LINE": "{d} · износ {wear}% · риск {risk}%",
  "CL-CAR-CANCEL": "Отмена",
  "CL-CAR-RETURNS-AT": "Вернётся в {time}",
  "CL-CAR-WEAR": "Износ узлов: −{p}%",
  "CL-CAR-RISK-EXPLAIN": "При поломке — половина добычи. Совсем без награды не бывает",
  "CL-CAR-NO-ENERGY": "Энергия не нужна",
  "CL-CAR-ON-ROAD": "В пути",
  "CL-VISIT-NOT-NEIGHBOR": "В гости — к друзьям и соседям по кооперативу",
  "CL-VISIT-ALREADY": "Сегодня уже сидели",
  "CL-VISIT-HOSTS-LIMIT": "На сегодня в гостях хватит",
  "CL-VISIT-NO-BENCH": "У хозяина пока нет лавочки",
  "CL-VISIT-DONE": "Посидели ✓",
  "CL-VISIT-WEEK-DMG": "Урон за неделю",
  "CL-VISIT-BOSSES": "Боссов побито",
  "CL-VISIT-SOON": "{what} — скоро",
  "CL-CHAR-LVL": "ур. {n}",
  "CL-VISIT-GARAGE": "Гараж",
  "CL-VISIT-NODE": "{node} {n}",
  "CL-VISIT-NODE-ENGINE": "Двигатель",
  "CL-VISIT-NODE-BODY": "Кузов",
  "CL-VISIT-NODE-CHASSIS": "Ходовая",
  "T-RIDE-GO": "Ехать",
  "T-RIDE-RISK": "Риск поломки: {pct}%",
  "UI-CAR-TITLE": "Ласточка",
  "UI-HOME-CAR-BACK": "Вернулась",
  "UI-ZONE-LEVEL": "Уровень {n} из {max}",
  "UI-ZONE-BUILD": "Строить за {cost}",
  "UI-ZONE-BUSY": "Сейчас строится {zone}. Стройка одна за раз",
  "UI-ZONE-ACCEPT": "Принять работу",
  "UI-ZONE-GUESTS": "Это увидят соседи, когда зайдут в гости",
  "UI-GAR-ZONE-LVL": "{zone}, уровень {lvl}",
  "UI-GAR-ZONE-MAX": "Лучше уже не сделать",
  "T-CAR-CONDITION": "Состояние {p}%",
  "T-NODE-PATCH-ALL-COST": "Подлатать всё за {cost}",
  "T-NODE-PATCH-COST": "Подлатать за {cost}",
  "T-NODE-MAX": "Узел в идеале",
  "UI-NAV-PROFILE": "Профиль",
  "UI-BTN-RESPECT": "Уважить",
  "RANK-RESPECT-MONTH": "Уважение",
  "PROF-VISIT": "Зайти в гости",
  "PROF-ADD-FRIEND": "В друзья",
  "PROF-VISIT-LOCKED": "Гараж на замке: хозяин гостей не пускает",
  "PROF-VISIT-SELF": "Так твой гараж видят соседи",
  "COOP-CHAT-REPORT": "Пожаловаться",
  "CL-NET-ERROR-POLICY-CANCEL-WINDOW": "Отменить можно только в первые 5 минут. Стройка идёт, ресурсы в деле",
  "CL-NET-ERROR-POLICY-TRIP-RUNNING": "Машина уже в пути",
  "CL-NET-ERROR-POLICY-NOT-RUNNING": "Машина уже вернулась — талоны целы",
  "CL-NET-ERROR-POLICY-NOT-FINISHED": "Ещё не вернулась",
  "CL-NET-ERROR-POLICY-CAR-NOT-READY": "Сначала подлатай машину",
  "CL-NET-ERROR-POLICY-RESPECTED-TODAY": "Сегодня ты уже уважил этого соседа",
  "CL-NET-ERROR-POLICY-SELF": "С собой так нельзя",
  "CL-NET-ERROR-POLICY-FRIENDS-LIMIT": "Друзей уже 100 — больше нельзя",
  "CL-NET-ERROR-POLICY-ALREADY-REPORTED": "Жалоба уже у модератора",
  "CL-NET-ERROR-POLICY-PAYLOAD-TOO-LARGE": "Слишком большой запрос",
  "CL-NET-ERROR-POLICY-HAS-PENDING-PAYMENTS": "Есть покупка в обработке — удалить аккаунт можно после неё",
  "CL-NET-ERROR-POLICY-DELETE-ALREADY-SCHEDULED": "Удаление уже запланировано",
  "CL-NET-ERROR-POLICY-BODY-INVALID": "Пустое или слишком длинное сообщение",
  "CL-NET-ERROR-POLICY-NOT-COMPLETED": "Задание ещё не выполнено",
  "CL-NET-ERROR-POLICY-URL-INVALID": "Это не похоже на ссылку-приглашение",
  "CL-NET-ERROR-POLICY-COOP-NAME-TAKEN": "Название занято",
  "CL-NET-ERROR-POLICY-COOP-NAME-INVALID": "Название не подходит",
  "CL-NET-ERROR-POLICY-COOP-REJOIN-COOLDOWN": "Вступить снова можно через сутки",
  "CL-NET-ERROR-POLICY-COOP-CHAIRMAN-MUST-TRANSFER": "Сначала передай председательство",
  "CL-NET-ERROR-POLICY-COOP-NOT-SCHEDULED": "Отменять нечего",
  "CL-NET-ERROR-POLICY-COOP-DISBAND-SCHEDULED": "Идёт голосование о роспуске",
  "CL-NET-ERROR-POLICY-COOP-INSTANCE-ACTIVE": "Босс уже вызван",
  "CL-NET-ERROR-POLICY-COOP-NO-SUMMONS": "Нет объявлений о сборе",
  "CL-NET-ERROR-POLICY-COOP-BOSS-NOT-ELIGIBLE": "Этого босса в одиночку победили меньше пяти соседей",
  "CL-NET-ERROR-POLICY-COOP-NO-PLANS": "Нет планов на постройку",
  "CL-NET-ERROR-POLICY-COOP-COOP-LEVEL-TOO-LOW": "Нужен уровень кооператива выше",
  "CL-NET-ERROR-POLICY-COOP-BUILDING-MAX": "Постройка на потолке",
  "CL-NET-ERROR-POLICY-COOP-STORAGE-FULL": "Склад переполнен",
  "CL-NET-ERROR-POLICY-COOP-TENURE-TOO-SHORT": "Нужен стаж в кооперативе от суток",
  "CL-APP-APP-ALL": "Всё",
  "CL-FIGHT-CONTROLLER-HIT": "удар",
  "CL-SCREENS-INVENTORY-SCRAP-TO": " → {n} лома",
  "CL-SCREENS-INVENTORY-SCRAP-PLUS": " + {n} лома",
  "CL-UI-KIT-POINTS": ", есть свободные очки",
  "ASM-WISH-TEXT-BAD": "Такую надпись нельзя",
  "CL-APP-APP-01": "Не вышло",
  "CL-APP-APP-02": "Не вышло. {p0} на месте",
  "CL-APP-APP-03": "Не так быстро — подожди {p0} с",
  "CL-APP-APP-04": "Повторить",
  "CL-BOOT-BOOT-01": "Не узнали тебя. Открой игру заново из Telegram",
  "CL-BOOT-BOOT-02": "Не грузится. Проверь связь",
  "CL-FIGHT-CONTROLLER-01": "{p0} (время)",
  "CL-FIGHT-CONTROLLER-02": "Ты: {p0} — мимо",
  "CL-FIGHT-CONTROLLER-03": "Ты: {p0} — {p1}{p2}",
  "CL-FIGHT-CONTROLLER-04": "{p0}: {p1} — увернулся",
  "CL-FIGHT-CONTROLLER-05": "{p0}: {p1} — тебе −{p2}",
  "CL-FIGHT-CONTROLLER-06": "Разъедание — {p0}",
  "CL-FIGHT-CONTROLLER-07": "{p0} — тебе −{p1}",
  "CL-FIGHT-CONTROLLER-08": "Передышка — +{p0}",
  "CL-FIGHT-CONTROLLER-09": "{p0} лечится +{p1}",
  "CL-FIGHT-CONTROLLER-10": "{p0} прикрылся: щит {p1}",
  "CL-FIGHT-CONTROLLER-11": "⚠ {p0} готовит {p1}",
  "CL-FIGHT-CONTROLLER-12": "{p0} пропускает ход",
  "CL-FIGHT-CONTROLLER-13": "{p0} добили: {p1}",
  "CL-MAIN-01": "Сессия устарела. Открой игру заново",
  "CL-NET-ERROR-POLICY-01": "Не хватает {p0}. Ничего не списано",
  "CL-NET-ERROR-POLICY-02": "Не вышло. Всё на месте — повтори",
  "CL-NET-ERROR-POLICY-03": "Связь пропала. Прогресс не потерян — всё на сервере",
  "CL-NET-ERROR-POLICY-04": "Сервер долго думает. Ничего не списано",
  "CL-NET-ERROR-POLICY-05": "Проверь, что введено",
  "CL-NET-ERROR-POLICY-06": "Не узнали тебя. Открой игру заново из Telegram",
  "CL-NET-ERROR-POLICY-07": "Сессия устарела. Открой игру заново",
  "CL-NET-ERROR-POLICY-08": "Это может председатель или заместитель",
  "CL-NET-ERROR-POLICY-09": "На ремонте. Остальная игра работает",
  "CL-NET-ERROR-POLICY-10": "Сначала закроем долг по талонам",
  "CL-NET-ERROR-POLICY-11": "Покупки временно недоступны. Звёзды не списаны. Вопросы — /paysupport",
  "CL-NET-ERROR-POLICY-12": "Покупки — через Telegram. Привяжи аккаунт",
  "CL-NET-ERROR-POLICY-13": "Писать пока нельзя",
  "CL-NET-ERROR-POLICY-14": "Теперь только по заявке",
  "CL-NET-ERROR-POLICY-15": "Руководство заморожено поддержкой",
  "CL-NET-ERROR-POLICY-16": "Правила обновились",
  "CL-NET-ERROR-POLICY-17": "Достигнут твой лимит трат. Звёзды не списаны",
  "CL-NET-ERROR-POLICY-18": "Не нашли — возможно, его уже нет",
  "CL-NET-ERROR-POLICY-19": "Пока ты думал, всё поменялось. Показали свежее — проверь и повтори",
  "CL-NET-ERROR-POLICY-20": "У тебя незаконченный бой",
  "CL-NET-ERROR-POLICY-21": "Ты уже в кооперативе",
  "CL-NET-ERROR-POLICY-22": "Мест нет",
  "CL-NET-ERROR-POLICY-23": "Уже 5 заявок — отзови одну",
  "CL-NET-ERROR-POLICY-24": "Набор разобрали — тираж закончился. Звёзды не списаны",
  "CL-NET-ERROR-POLICY-25": "Этот набор можно купить один раз. Он уже твой",
  "CL-NET-ERROR-POLICY-26": "Босса уже добили — награда в итогах",
  "CL-NET-ERROR-POLICY-27": "Сбор уже закрыт. Гайки на месте",
  "CL-NET-ERROR-POLICY-28": "Витрина сменилась — вот новая",
  "CL-NET-ERROR-POLICY-29": "Цена поменялась — проверь и повтори",
  "CL-NET-ERROR-POLICY-30": "Уже на рассмотрении",
  "CL-NET-ERROR-POLICY-31": "Во время перевыборов это нельзя",
  "CL-NET-ERROR-POLICY-32": "Такое сочетание уже есть — поменяй узор или цвет",
  "CL-NET-ERROR-POLICY-33": "Переоденешься после боя",
  "CL-NET-ERROR-POLICY-34": "Это уже закончилось",
  "CL-NET-ERROR-POLICY-35": "гаек",
  "CL-NET-ERROR-POLICY-36": "солярки",
  "CL-NET-ERROR-POLICY-37": "талонов",
  "CL-NET-ERROR-POLICY-38": "ключей",
  "CL-NET-ERROR-POLICY-39": "билетов",
  "CL-NET-ERROR-POLICY-40": "лома",
  "CL-NET-ERROR-POLICY-41": "опыта мастера",
  "CL-NET-ERROR-POLICY-42": "жетонов",
  "CL-NET-ERROR-POLICY-43": "отметок",
  "CL-NET-ERROR-POLICY-44": "жетонов события",
  "CL-NET-ERROR-POLICY-45": "Нужен уровень повыше",
  "CL-NET-ERROR-POLICY-46": "Сначала дорасти до этого босса",
  "CL-NET-ERROR-POLICY-47": "Ещё на перезарядке",
  "CL-NET-ERROR-POLICY-48": "На сегодня всё. Снова завтра",
  "CL-NET-ERROR-POLICY-49": "На этой неделе всё. Снова в понедельник",
  "CL-NET-ERROR-POLICY-50": "Предел достигнут",
  "CL-NET-ERROR-POLICY-51": "Это твой предел на этот рейд",
  "CL-NET-ERROR-POLICY-52": "Так писать нельзя",
  "CL-NET-ERROR-POLICY-53": "Не выполнено требование",
  "CL-NET-ERROR-POLICY-54": "Так перенести нельзя",
  "CL-NET-ERROR-POLICY-55": "Мастерство — позже",
  "CL-NET-ERROR-POLICY-56": "Уже полный",
  "CL-NET-ERROR-POLICY-57": "Проверь число",
  "CL-NET-ERROR-POLICY-58": "Свободных очков меньше, чем ты раздал",
  "CL-NET-ERROR-POLICY-59": "Вещь под замком — сними замок",
  "CL-NET-ERROR-POLICY-60": "Сначала сними вещь",
  "CL-NET-ERROR-POLICY-61": "Это предел",
  "CL-NET-ERROR-POLICY-62": "С этим боссом так не выйдет. Энергия на месте",
  "CL-NET-ERROR-POLICY-63": "Ты больше не в кооперативе",
  "CL-NET-ERROR-POLICY-64": "Не так быстро",
  "CL-NET-ERROR-POLICY-65": "Сервер перегружен. Ничего не списано, пробуем снова",
  "CL-NET-ERROR-POLICY-66": "Telegram не выдал счёт. Звёзды не списаны",
  "CL-NET-ERROR-POLICY-67": "Сначала закончим обучение с Семёнычем",
  "CL-NET-ERROR-POLICY-68": "Приём откроется позже",
  "CL-NET-ERROR-POLICY-69": "Это предел характеристики на твоём уровне",
  "CL-PAY-FLOW-01": "Стартовый",
  "CL-PAY-FLOW-02": "Горсть",
  "CL-PAY-FLOW-03": "Пачка",
  "CL-PAY-FLOW-04": "Коробка",
  "CL-PAY-FLOW-05": "Мешок",
  "CL-PAY-FLOW-06": "Вагон",
  "CL-PAY-FLOW-07": "×{p0} · один раз",
  "CL-SCENE-STAGE-01": "мимо",
  "CL-SCENE-STAGE-02": "увернулся",
  "CL-SCREENS-CHAR-01": "Фигура персонажа",
  "CL-SCREENS-CHAR-02": "{p0}: пусто",
  "CL-SCREENS-CHAR-03": "Сумка",
  "CL-SCREENS-CHAR-04": "Раздать очки",
  "CL-SCREENS-CHAR-05": "ур.",
  "CL-SCREENS-CHAR-06": "Персонаж",
  "CL-SCREENS-CHAR-07": "Опыт мастера:",
  "CL-SCREENS-CHAR-08": "опыта",
  "CL-SCREENS-CHAR-09": "Свободных очков:",
  "CL-SCREENS-CHAR-10": "Очки",
  "CL-SCREENS-CHAR-11": "Отменить",
  "CL-SCREENS-CHAR-12": "Понятно",
  "CL-SCREENS-CHAR-13": "Характеристики",
  "CL-SCREENS-CHAR-14": "Свободно:",
  "CL-SCREENS-CHAR-15": "Убрать: {p0}",
  "CL-SCREENS-CHAR-16": "Добавить: {p0}",
  "CL-SCREENS-CHAR-17": "Боевые величины пересчитает сервер после сохранения",
  "CL-SCREENS-CHAR-18": "Приём «{p0}»",
  "CL-SCREENS-CHAR-19": "Босс: {p0}",
  "CL-SCREENS-CHAR-20": "Уровни {p0}–{p1}",
  "CL-SCREENS-CHAR-21": "Уровень {p0}",
  "CL-SCREENS-CHAR-22": "очка характеристик",
  "CL-SCREENS-CHAR-23": "Открылось",
  "CL-SCREENS-FIGHT-01": "Босса добили! Твой урон засчитан",
  "CL-SCREENS-FIGHT-02": "Бой оставлен",
  "CL-SCREENS-FIGHT-03": "Бой отменён — энергию вернули",
  "CL-SCREENS-FIGHT-04": ", ещё {p0} хода",
  "CL-SCREENS-FIGHT-05": ", не хватает солярки",
  "CL-SCREENS-FIGHT-06": "Не хватает солярки",
  "CL-SCREENS-FIGHT-07": "Осталось {p0} с",
  "CL-SCREENS-FIGHT-08": "Связь пропала",
  "CL-SCREENS-FIGHT-09": "Бой ждёт {p0} с",
  "CL-SCREENS-FIGHT-10": "Ждём связь, урон сохранён на сервере",
  "CL-SCREENS-FIGHT-11": "Раунд",
  "CL-SCREENS-FIGHT-12": "Выключить звук",
  "CL-SCREENS-FIGHT-13": "Включить звук",
  "CL-SCREENS-FIGHT-14": "готовит",
  "CL-SCREENS-FIGHT-15": "Держи:",
  "CL-SCREENS-FIGHT-16": "Домкрат · Передышка",
  "CL-SCREENS-FIGHT-17": "Береги HP",
  "CL-SCREENS-FIGHT-18": "Ждём ответа",
  "CL-SCREENS-FIGHT-19": "Ты",
  "CL-SCREENS-FIGHT-20": "Солярка {p0}",
  "CL-SCREENS-FIGHT-21": "Выбери приём",
  "CL-SCREENS-FIGHT-22": "Заход без твоего выбора не даст допуск к награде",
  "CL-SCREENS-FIGHT-23": "Уйти из боя?",
  "CL-SCREENS-FIGHT-24": "Урон засчитается, энергия не вернётся",
  "CL-SCREENS-FIGHT-25": "Это поражение. Энергия не вернётся",
  "CL-SCREENS-FIGHT-26": "Уйти",
  "CL-SCREENS-FIGHT-27": "Добит другими",
  "CL-SCREENS-FIGHT-28": "Выбит",
  "CL-SCREENS-FIGHT-29": "Бой отменён",
  "CL-SCREENS-FIGHT-30": "К карте",
  "CL-SCREENS-FIGHT-31": "Ещё бой · {p0}",
  "CL-SCREENS-FIGHT-32": "Восполнить силы",
  "CL-SCREENS-FIGHT-33": "Считаем урон…",
  "CL-SCREENS-FIGHT-34": "раундов",
  "CL-SCREENS-FIGHT-35": "Всего твой урон:",
  "CL-SCREENS-FIGHT-36": "· место",
  "CL-SCREENS-FIGHT-37": "Подробнее ›",
  "CL-SCREENS-FIGHT-38": "Победа в одиночку засчитана",
  "CL-SCREENS-FIGHT-39": "В одиночном бою уход — это поражение",
  "CL-SCREENS-FIGHT-40": "Поражение: награда за попытку",
  "CL-SCREENS-FIGHT-41": "Награды",
  "CL-SCREENS-FIGHT-42": "опыта",
  "CL-SCREENS-FIGHT-43": "В этот раз без наград",
  "CL-SCREENS-FIGHT-44": "Опыт",
  "CL-SCREENS-FIGHT-45": "вернули",
  "CL-SCREENS-FIGHT-46": "Осталось",
  "CL-SCREENS-FIGHT-47": "— ещё",
  "CL-SCREENS-FIGHT-48": "бой",
  "CL-SCREENS-FIGHT-49": "боя",
  "CL-SCREENS-FIGHT-50": "Вклад",
  "CL-SCREENS-FIGHT-51": "Понятно",
  "CL-SCREENS-FIGHT-52": "Таблица всех участников появится вместе с общими боями",
  "CL-SCREENS-FIGHT-53": "Будьте первым",
  "CL-SCREENS-HOME-01": "Замок на воротах",
  "CL-SCREENS-INVENTORY-01": "Отмена",
  "CL-SCREENS-INVENTORY-02": "Разобрать ({p0}){p1}",
  "CL-SCREENS-INVENTORY-03": "Выбери вещи",
  "CL-SCREENS-INVENTORY-04": "Разобрать лишнее",
  "CL-SCREENS-INVENTORY-05": "Слот",
  "CL-SCREENS-INVENTORY-06": "Все",
  "CL-SCREENS-INVENTORY-07": "Редкость",
  "CL-SCREENS-INVENTORY-08": "Любая",
  "CL-SCREENS-INVENTORY-09": "Сумка",
  "CL-SCREENS-INVENTORY-10": "Нет связи — сумка из кэша, разбор недоступен",
  "CL-SCREENS-INVENTORY-11": "Всё хуже надетого",
  "CL-SCREENS-INVENTORY-12": "К боссам",
  "CL-SCREENS-INVENTORY-13": "Надетое не разбирается — сначала сними",
  "CL-SCREENS-INVENTORY-14": "Вещь",
  "CL-SCREENS-INVENTORY-15": "Нужен {p0} уровень",
  "CL-SCREENS-INVENTORY-16": "Вещи",
  "CL-SCREENS-INVENTORY-17": "Сравнение с надетым:",
  "CL-SCREENS-INVENTORY-18": "Под замком",
  "CL-SCREENS-INVENTORY-19": "Без замка",
  "CL-SCREENS-INVENTORY-20": "Готово: +{p0}",
  "CL-SCREENS-INVENTORY-21": "Это предел",
  "CL-SCREENS-INVENTORY-22": "Не хватает {p0}",
  "CL-SCREENS-INVENTORY-23": "Не хватает {p0} лома",
  "CL-SCREENS-INVENTORY-24": "Улучшить за {p0}{p1}",
  "CL-SCREENS-INVENTORY-25": "Цену назовёт сервер при улучшении",
  "CL-SCREENS-INVENTORY-26": "Улучшение всегда успешно",
  "CL-SCREENS-INVENTORY-27": "Разобрано: +{p0} лома",
  "CL-SCREENS-INVENTORY-28": "Продано: +{p0} гаек",
  "CL-SCREENS-INVENTORY-29": "Продать скупщику?",
  "CL-SCREENS-INVENTORY-30": "Подожди…",
  "CL-SCREENS-INVENTORY-31": "и ещё",
  "CL-SCREENS-INVENTORY-32": "Получишь:",
  "CL-SCREENS-INVENTORY-33": "{p0} лома",
  "CL-SCREENS-INVENTORY-34": "{p0} гаек",
  "CL-SCREENS-INVENTORY-35": "по ответу сервера",
  "CL-SCREENS-INVENTORY-36": "Среди них",
  "CL-SCREENS-INVENTORY-37": "легендарная",
  "CL-SCREENS-INVENTORY-38": "эпическая",
  "CL-SCREENS-INVENTORY-39": "Улучшение не вернётся",
  "CL-SCREENS-INVENTORY-40": "Вернуть вещи будет нельзя",
  "CL-SCREENS-INVENTORY-41": "Продажа за гайки, вещи уйдут из сумки",
  "CL-SCREENS-MAP-01": "Боссы",
  "CL-SCREENS-MAP-02": "Карта на",
  "CL-SCREENS-MAP-03": "— нет связи",
  "CL-SCREENS-MAP-04": "Карта не загрузилась",
  "CL-SCREENS-MAP-05": "Повторить",
  "CL-SCREENS-MAP-06": "· закрыт",
  "CL-SCREENS-MAP-07": "Сначала разберись с: {p0}",
  "CL-SCREENS-MAP-08": "с {p0}-го уровня",
  "CL-SCREENS-MAP-09": "Район",
  "CL-SCREENS-MAP-10": "ур. 1–10",
  "CL-SCREENS-MAP-11": " · босс района",
  "CL-SCREENS-MAP-12": "С {p0}-го уровня",
  "CL-SCREENS-MAP-13": "ур. {p0}",
  "CL-SCREENS-MAP-14": "Доступна «Зачистка»",
  "CL-SCREENS-MAP-15": "Доступна Зачистка",
  "CL-SCREENS-MAP-16": "Босс сильнее тебя на 3+ ур.",
  "CL-SCREENS-MAP-17": "Босс сильнее тебя",
  "CL-SCREENS-MAP-18": "Дальше — скоро",
  "CL-SCREENS-MAP-19": "У тебя незаконченный бой",
  "CL-SCREENS-MAP-20": "Солярки не хватило — бак не залит, энергия на месте",
  "CL-SCREENS-MAP-21": "Сервер не ответил. Энергия на месте",
  "CL-SCREENS-MAP-22": "Энергия",
  "CL-SCREENS-MAP-23": "Вернуться в бой",
  "CL-SCREENS-MAP-24": "Соединяемся…",
  "CL-SCREENS-MAP-25": "В бой · {p0}",
  "CL-SCREENS-MAP-26": "· ур.",
  "CL-SCREENS-MAP-27": "полный в каждом заходе",
  "CL-SCREENS-MAP-28": "Побед:",
  "CL-SCREENS-MAP-29": "Цена захода",
  "CL-SCREENS-MAP-30": "· у тебя",
  "CL-SCREENS-MAP-31": "Босс сильнее тебя на",
  "CL-SCREENS-MAP-32": "ур. — заход может кончиться быстро",
  "CL-SCREENS-MAP-33": "Объявляет заранее — держи Домкрат или Передышку",
  "CL-SCREENS-MAP-34": "Полный бак: +25% урона за 3 солярки",
  "CL-SCREENS-MAP-35": "У тебя",
  "CL-SCREENS-MAP-36": "Нужно",
  "CL-SCREENS-MAP-37": "— нажми, чтобы восполнить силы",
  "CL-SCREENS-MAP-38": "Понятно",
  "CL-SCREENS-MAP-39": "Откроется на",
  "CL-SCREENS-MAP-40": "уровне. Ты на",
  "CL-SCREENS-MAP-41": "-м",
  "CL-SCREENS-MAP-42": ": ещё {p0} опыта",
  "CL-SCREENS-MAP-43": "Опыт дают бои с открытыми боссами",
  "CL-SCREENS-MODALS-01": "Бои с боссами",
  "CL-SCREENS-MODALS-02": "Продажа вещей скупщику",
  "CL-SCREENS-MODALS-03": "Ларёк: пакеты талонов",
  "CL-SCREENS-MODALS-04": "Награды за бои",
  "CL-SCREENS-MODALS-05": "Разбор вещей в сумке",
  "CL-SCREENS-MODALS-06": "Награды заданий — с альфы",
  "CL-SCREENS-MODALS-07": "Улучшение вещей",
  "CL-SCREENS-MODALS-08": "Стройка в гараже",
  "CL-SCREENS-MODALS-09": "Термос, ускорения, вид",
  "CL-SCREENS-MODALS-10": "«Полный бак» и особые приёмы",
  "CL-SCREENS-MODALS-11": "Мини-игры",
  "CL-SCREENS-MODALS-12": "Пополнить",
  "CL-SCREENS-MODALS-13": "Где взять",
  "CL-SCREENS-MODALS-14": "На что тратить",
  "CL-SCREENS-MODALS-15": "Энергия",
  "CL-SCREENS-MODALS-16": "Понятно",
  "CL-SCREENS-MODALS-17": "Для боя нужно",
  "CL-SCREENS-MODALS-18": "энергии",
  "CL-SCREENS-MODALS-19": ", у тебя {p0}",
  "CL-SCREENS-MODALS-20": "+1 через",
  "CL-SCREENS-MODALS-21": "Термос наполнится через",
  "CL-SCREENS-MODALS-22": "+1 за 3 мин, максимум",
  "CL-SCREENS-MODALS-23": "с альфы",
  "CL-SCREENS-MODALS-24": "Нет связи — время по последним данным",
  "CL-SCREENS-MODALS-25": "Награда",
  "CL-SCREENS-MODALS-26": "Точно?",
  "CL-SCREENS-MODALS-27": "Да",
  "CL-SCREENS-MODALS-28": "Подожди…",
  "CL-SCREENS-MODALS-29": "Игра открыта в другом месте",
  "CL-SCREENS-MODALS-30": "Играть здесь",
  "CL-SCREENS-MODALS-31": "Правила обновились",
  "CL-SCREENS-MODALS-32": "Прочитай изменения и подтверди, чтобы продолжить",
  "CL-SCREENS-MODALS-33": "Принимаю",
  "CL-SCREENS-MODALS-34": "Теперь ты свой",
  "CL-SCREENS-MODALS-35": "Семёныч жмёт руку. Гараж твой, шапка на голове, гайки в кармане.",
  "CL-SCREENS-MODALS-36": "В гараж",
  "CL-SCREENS-MODALS-37": "• Бои — во вкладке «Город»",
  "CL-SCREENS-MODALS-38": "• Вещи и характеристики — «Персонаж»",
  "CL-SCREENS-MODALS-39": "• Талоны — в «Ларьке»",
  "CL-SCREENS-SETTINGS-01": "Ведущая рука: левая",
  "CL-SCREENS-SETTINGS-02": "Светлая",
  "CL-SCREENS-SETTINGS-03": "Тёмная",
  "CL-SCREENS-SETTINGS-04": "Сборка 0.1.0 · прототип",
  "CL-SCREENS-STORE-01": "Начисляем покупку «",
  "CL-SCREENS-STORE-02": " Не начислено за 15 минут — напиши в поддержку, номер заказа {p0}",
  "CL-SCREENS-STORE-03": "Магазин",
  "CL-SCREENS-STORE-04": "Нет связи — покупки недоступны",
  "CL-SCREENS-STORE-05": "Ларёк пока пуст",
  "CL-SCREENS-STORE-06": "Оплата звёздами Telegram. Покупка не передаётся и не выводится",
  "CL-SCREENS-STORE-07": "Оплата выключена",
  "CL-SCREENS-STORE-08": "Лимит трат исчерпан",
  "CL-SCREENS-STORE-09": "Оплатить {p0}",
  "CL-SCREENS-STORE-10": "Один раз",
  "CL-SCREENS-STORE-11": "У тебя",
  "CL-SCREENS-STORE-12": "Оплата звёздами Telegram. Покупка не передаётся и не выводится.",
  "CL-SCREENS-STORE-13": "Правила покупок",
  "CL-SCREENS-STORE-14": "Ждём зачисления",
  "CL-SCREENS-STORE-15": "Оплата прошла. Начисляем…",
  "CL-SCREENS-STORE-16": "Telegram подтвердил оплату, ждём зачисления. Начислим сами — придёт уведомление",
  "CL-SCREENS-STORE-17": "Telegram ещё проверяет платёж",
  "CL-SCREENS-STORE-18": "Семёныч пересчитывает талоны",
  "CL-SCREENS-STORE-19": "Поддержка",
  "CL-SCREENS-STORE-20": "Свернуть — начислим сами",
  "CL-SCREENS-STORE-21": "Заказ",
  "CL-SCREENS-STORE-22": "Отлично",
  "CL-SCREENS-STORE-23": "Готово:",
  "CL-SCREENS-STORE-24": "талонов на счету",
  "CL-SCREENS-STORE-25": "Баланс:",
  "CL-SCREENS-STORE-26": "Оплата не прошла. Звёзды не списаны",
  "CL-SCREENS-STORE-27": "Тираж разобрали, пока ты выбирал",
  "CL-SCREENS-STORE-28": "Это уже у тебя — этот набор покупается один раз",
  "CL-SCREENS-STORE-29": "Предложение закончилось",
  "CL-SCREENS-STORE-30": "Покупки временно недоступны. Напиши в поддержку — /paysupport",
  "CL-SCREENS-STORE-31": "Слишком много заказов подряд. Подожди минуту",
  "CL-SCREENS-STORE-32": "Telegram не выдал счёт. Звёзды не списаны",
  "CL-SCREENS-STORE-33": "Покупки — через Telegram. Привяжи аккаунт",
  "CL-SCREENS-STORE-34": "Магазин не ответил. Звёзды не списаны",
  "CL-SCREENS-STORE-35": "{p0}. Попробуй через {p1} с",
  "CL-SCREENS-STORE-36": "Покупка не прошла",
  "CL-SCREENS-STORE-37": "Попробовать снова",
  "CL-SCREENS-SYSTEM-01": "Смазываем петли ворот…",
  "CL-SCREENS-SYSTEM-02": "Семёныч заваривает чай…",
  "CL-SCREENS-SYSTEM-03": "Пересчитываем гайки…",
  "CL-SCREENS-SYSTEM-04": "Прогреваем мотор…",
  "CL-SCREENS-SYSTEM-05": "Гаражи",
  "CL-SCREENS-SYSTEM-06": "Не узнали тебя",
  "CL-SCREENS-SYSTEM-07": "Не грузится",
  "CL-SCREENS-SYSTEM-08": "Открой игру заново из Telegram",
  "CL-SCREENS-SYSTEM-09": "Открыть заново",
  "CL-SCREENS-SYSTEM-10": "Повторить",
  "CL-SCREENS-SYSTEM-11": "Не грузится. Проверь связь",
  "CL-SCREENS-SYSTEM-12": "Медленная сеть, ещё немного…",
  "CL-SCREENS-SYSTEM-13": "Telegram слишком старый — обнови его",
  "CL-SCREENS-SYSTEM-14": "Телефон не тянет графику игры",
  "CL-SCREENS-SYSTEM-15": "Игре нужна версия Telegram посвежее. Прогресс сохранится.",
  "CL-SCREENS-SYSTEM-16": "Нет поддержки WebGL. Попробуй открыть игру в браузере.",
  "CL-SCREENS-SYSTEM-17": "Обновить Telegram",
  "CL-SCREENS-SYSTEM-18": "Открыть в браузере",
  "CL-SCREENS-SYSTEM-19": "Вышло обновление",
  "CL-SCREENS-SYSTEM-20": "Перезапустить",
  "CL-SCREENS-SYSTEM-21": "Переучёт",
  "CL-SCREENS-SYSTEM-22": "Меняем масло на сервере. Вернёмся к",
  "CL-SCREENS-SYSTEM-23": "МСК",
  "CL-SCREENS-SYSTEM-24": " (через {p0})",
  "CL-SCREENS-SYSTEM-25": "Ворота закрыты, но всё на месте",
  "CL-SCREENS-SYSTEM-26": "Пробуем открыть ворота…",
  "CL-SCREENS-SYSTEM-27": "Канал игры",
  "CL-SCREENS-SYSTEM-28": "Доступ к игре закрыт",
  "CL-SCREENS-SYSTEM-29": "до {p0}",
  "CL-SCREENS-SYSTEM-30": "навсегда",
  "CL-SCREENS-SYSTEM-31": "Причина: нарушение правил (",
  "CL-SCREENS-SYSTEM-32": "Оспорить",
  "CL-SCREENS-SYSTEM-33": "Нет связи с гаражом",
  "CL-SCREENS-SYSTEM-34": "Что-то сломалось. Мы уже знаем",
  "CL-SCREENS-SYSTEM-35": "Отчёт ушёл механикам. Прогресс и покупки в сохранности.",
  "CL-SCREENS-SYSTEM-36": "Поддержка",
  "CL-SCREENS-SYSTEM-37": "код",
  "CL-TUTORIAL-FLOW-01": "Что-то заело, пробуем ещё раз",
  "CL-TUTORIAL-LETTER-01": "Играя, ты принимаешь",
  "CL-TUTORIAL-LETTER-02": "правила игры",
  "CL-TUTORIAL-OVERLAY-01": "Повторить",
  "CL-UI-APP-01": "Поверни телефон",
  "CL-UI-KIT-01": "Персонаж, уровень {p0}{p1}",
  "CL-UI-KIT-02": "Персонаж",
  "CL-UI-KIT-03": "Энергия",
  "CL-UI-KIT-04": "Пополнить талоны",
  "CL-UI-KIT-05": "ур.",
  "CL-UI-KIT-06": "Нет связи · пробуем снова",
  "CL-UI-KIT-07": " · данные на {p0}",
  "CL-UI-KIT-08": "Связь есть",
  "CL-UI-KIT-09": "Что-то часто ломается. Перезапустить игру?",
  "CL-UI-KIT-10": "Перезапустить",
  "CL-UI-KIT-11": "Скрыть",
  "CL-UI-KIT-12": ", надета",
  "CL-UI-KIT-13": "Загрузка",
  "CL-UI-KIT-14": "не загрузилось. Всё на месте",
  "CL-UI-KIT-15": "Повторить",
  "ERR-NET": "Проверь интернет. Прогресс не потерян — всё на сервере.",
  "ERR-SESSION-OTHER": "Играть можно только в одном окне. Продолжить здесь?",
  "ERR-VERSION": "Перезапусти игру, чтобы получить новую версию.",
  "SHOP-PAY-OFF": "Звёзды на тесте не принимаем. Талоны на старт — уже у тебя",
  "SHOP-TAB-BOXES": "Ящики",
  "SHOP-TAB-TALONS": "Талоны",
  "TUT-T01-01": "Письмо с дачи",
  "TUT-T01-02": "Племяш! Гараж № 117 теперь твой. Ласточка под брезентом. Семёныч поможет. Твой дядя Витя",
  "TUT-T01-03": "Взять ключ",
  "TUT-T01-AUTO": "Ключ уже в кармане",
  "TUT-T02-01": "Витин наследник? Я Семёныч, сосед. Крути сильнее — замок прикипел.",
  "TUT-T02-02": "Тапни по замку три раза",
  "TUT-T02-03": "Ещё разок — он сдаётся",
  "TUT-T02-04": "Пошёл! Слышишь скрип? Это гараж тебе рад.",
  "TUT-T02-AUTO": "Дай-ка я помогу. Вот так — с душой.",
  "TUT-T03-01": "Это Шушера, всю проводку сгрызла. Гони её!",
  "TUT-T03-03": "Жми «Удар» — бей крысу",
  "TUT-T03-05": "Так её! Бей ещё",
  "TUT-T03-R": "Шушера опять в гараже. Ничего, второй раз проще.",
  "TUT-T04-02": "Шустрая! Кинь в неё ключом — так больнее.",
  "TUT-T04-03": "Жми «Бросок ключа»",
  "TUT-T04-04": "Цифра — сколько ходов ждать. Пока бей «Ударом»",
  "TUT-T04-06": "Ключ снова в руке — бросай!",
  "TUT-T04-08": "Шушера сбежала!",
  "TUT-T05-01": "Трофеи",
  "TUT-T05-02": "Гайки — местная валюта. На них чинят всё",
  "TUT-T05-03": "Вязаная шапка. Первая вещь в гардеробе",
  "TUT-T05-04": "Уровень 2! Очки раздали за тебя — переиграешь позже",
  "TUT-T05-05": "Неплохо для первого раза. Шапку прихвати — в гараже сквозит.",
  "TUT-T06-01": "Тапни по шапке, чтобы надеть",
  "TUT-T06-03": "Вещи дают силу. Новые падают в боях",
  "TUT-T06-04": "Вот, уже на человека похож.",
  "UI-BAG-EMPTY": "Здесь пока пусто. Вещи выпадают с боссов",
  "UI-BAG-PICK-COMMON": "Все обычные",
  "UI-BTN-BACK": "Назад",
  "UI-BTN-CLOSE": "Закрыть",
  "UI-BTN-COLLECT": "Забрать",
  "UI-BTN-EQUIP": "Надеть",
  "UI-BTN-FIGHT": "В бой",
  "UI-BTN-LATER": "Позже",
  "UI-BTN-SAVE": "Сохранить",
  "UI-BTN-SELL": "Продать",
  "UI-BTN-UNEQUIP": "Снять",
  "UI-BTN-UPGRADE": "Улучшить",
  "UI-CHAR-POWER": "Справность",
  "UI-DISM-TITLE": "Разобрать на запчасти?",
  "UI-ENERGY-FULL": "Термос до краёв",
  "UI-ENERGY-THERMOS": "Запасной термос",
  "UI-ENERGY-TITLE": "Термос пустой",
  "UI-FIGHT-FINISHED-ME": "Добили!",
  "UI-FIGHT-KO": "На минутку",
  "UI-FIGHT-LEAVE-STAY": "Остаться",
  "UI-FIGHT-ROUNDS-OVER": "Раунды кончились",
  "UI-FIGHT-START": "Бой!",
  "CL-FIGHT-TURN-YOU": "Твой ход",
  "CL-FIGHT-TURN-BOSS": "Ход босса",
  "UI-FIGHT-WIN": "Победа!",
  "UI-ITEM-DISMANTLE": "Разобрать",
  "UI-LOADING-3": "Ищем ключ на тринадцать…",
  "UI-NAV-HOME": "Гараж",
  "UI-NAV-MAP": "Город",
  "UI-NAV-SHOP": "Ларёк",
  "UI-OFFLINE": "Нет связи",
  "UI-RES-NUTS": "Гайки",
  "UI-RESULT-DAMAGE": "Урон за заход",
  "UI-SET-FULLSCREEN": "Во весь экран",
  "UI-SET-HAPTICS": "Вибрация",
  "UI-SET-THEME": "Тема",
  "UI-SET-THEME-SYSTEM": "Как в Telegram",
  "UI-SET-TITLE": "Настройки",
  "UI-SKILL-NEW": "Новый приём",
  "UI-STAT-CHA": "Харизма",
  "UI-STAT-DEX": "Сноровка",
  "UI-STAT-STR": "Сила",
  "UI-STAT-VIT": "Живучесть",
  "UI-STATS-AUTO": "Раздать за меня",
  "UI-UPGRADE-TITLE": "Улучшение",
  // --- Магазин и предметы (фронтенд-2: E12-T11…T22, E05) ---
  "CL-STORE-TAB-SETS": "Наборы",
  "CL-STORE-TAB-SHOP": "Лавка",
  "CL-STORE-TAB-ENERGY": "Энергия",
  "CL-STORE-TAB-BOOSTS": "Ускорения",
  "CL-STORE-TAB-LOOKS": "Вид",
  "CL-STORE-TAB-MISC": "Всякое",
  "CL-STORE-PURCHASES": "Покупки",
  "CL-STORE-STARS-A11Y": "звёзд Telegram",
  "CL-STORE-APPROX": "≈",
  "CL-STORE-RUB": "≈ {n} ₽",
  "CL-STORE-RUB-NOTE": "Рубли — по розничной цене звёзд, примерно. Точная сумма — в окне оплаты Telegram",
  "CL-STORE-HOLD": "держи 1 с",
  "CL-STORE-G-THERMOS": "Термос",
  "CL-STORE-G-BOOST": "Аврал: +100% урона",
  "CL-STORE-G-NUTS": "Ведро гаек",
  "CL-STORE-G-BOX": "Ящик мастера",
  "CL-STORE-G-BOX10": "Ящик мастера ×10",
  "CL-STORE-G-LAVKA-GOOD": "Часть сета, хорошая",
  "CL-STORE-G-LAVKA-RARE": "Часть сета, редкая",
  "CL-STORE-G-LAVKA-EPIC": "Часть сета, эпическая",
  "CL-STORE-G-LAVKA-S8": "Часть «Председателя»",
  "CL-STORE-G-RENAME": "Смена имени",
  "CL-STORE-G-FRAME": "Рамка профиля",
  "CL-STORE-G-EMBLEM": "Эмблема кооператива",
  "CL-STORE-G-PASS": "Членская книжка сезона",
  "CL-STORE-G-LOOK": "Внешний вид",
  "CL-STORE-G-ANY": "Товар",
  "CL-STORE-FIRST-FREE": "Первая — бесплатно",
  "CL-STORE-LIMIT-DAY": "Сегодня {k} из {n}",
  "CL-STORE-LIMIT-WEEK": "На неделе {k} из {n}",
  "CL-STORE-LIMIT-SEASON": "Один раз за сезон",
  "CL-STORE-LIMIT-ONCE": "Один раз",
  "CL-STORE-BUY-FOR": "Купить за {s} {n, plural, one {талон} few {талона} many {талонов} other {талона}}",
  "CL-STORE-LACK": "Не хватает {s} {n, plural, one {талон} few {талона} many {талонов} other {талона}}",
  "CL-STORE-DEBT-PRICE": "Сначала закроем долг",
  "CL-STORE-AGAIN-TOMORROW": "Снова завтра в 04:00",
  "CL-STORE-AGAIN-MONDAY": "Снова в понедельник 04:00",
  "CL-STORE-AGAIN-SEASON": "Снова в новом сезоне",
  "CL-STORE-SOON": "Скоро",
  "CL-STORE-DONE": "На сегодня всё",
  "CL-STORE-ODDS": "Шансы",
  "CL-STORE-HAVE": "У тебя {s} {n, plural, one {талон} few {талона} many {талонов} other {талона}}",
  "CL-STORE-LACK-STARS": "Не хватает ≈ {n}",
  "CL-STORE-TO-PACK": "Взять «{name}» ›",
  "CL-STORE-TALON-NOTE": "Покупка за талоны не передаётся и не выводится",
  "CL-STORE-DEBT-BANNER": "Долг {s} {n, plural, one {талон} few {талона} many {талонов} other {талона}}: сначала закроем его",
  "CL-STORE-DEBT-PACK": "Сначала закроем долг {d} талонов: получишь {k} из {n}",
  "CL-STORE-BACK-TO-BUY": "Вернуться к покупке",
  "CL-STORE-ERR-TALONS": "Талонов не хватает — баланс обновлён",
  "CL-STORE-ERR-DAY": "На сегодня всё. Снова завтра в 04:00",
  "CL-STORE-ERR-WEEK": "На этой неделе всё. Снова в понедельник",
  "CL-STORE-ERR-BOUGHT": "Это уже куплено",
  "CL-STORE-ERR-SAFE": "Не вышло. Талоны на месте",
  "CL-STORE-TALONS-SAFE": "Талоны",
  "CL-STORE-SETS-EMPTY": "Наборов к событиям пока нет. Новый появится баннером",
  "CL-STORE-FOR-YOU": "Для тебя",
  "CL-STORE-UNTIL": "до {t}",
  "CL-STORE-SHOWCASE-ERR": "Витрина не загрузилась — открой ещё раз",
  "CL-STORE-LAVKA": "Лавка Семёныча",
  "CL-STORE-LAVKA-REFRESH": "Новый завоз через {d} дн",
  "CL-STORE-LAVKA-EMPTY": "Семёныч ещё раскладывает товар",
  "CL-STORE-BOXES-EMPTY": "Ящиков сейчас нет",
  "CL-STORE-PITY": "До эпической: {g}",
  "CL-STORE-PITY-LEG": "до легендарной: {g}",
  "CL-STORE-WORST": "худший случай — {s} {n, plural, one {талон} few {талона} many {талонов} other {талона}}",
  "CL-STORE-SOON-TAB": "Скоро здесь появятся товары",
  "CL-STORE-THERMOS-LEFT": "Сегодня осталось {k} из {n}",
  "CL-STORE-THERMOS-OPEN": "Открыть",
  "CL-STORE-NO-ADS": "Термос — единственный способ быстро добрать энергию. Рекламы тут нет",
  "CL-STORE-BOOST-OFF": "Ускорения появятся во время рейда",
  "CL-STORE-BOOST-FAILED": "Сбор сорван — ускорение на этой неделе не продаётся",
  "CL-STORE-OFF-NOW": "Ларёк на переучёте. Звёзды и талоны на месте",
  "CL-STORE-LIMIT-REACHED": "Ты сам поставил лимит трат. Товары за звёзды — снова с {d}",
  "CL-THERMOS-TEXT": "Чай из термоса: +{n} энергии за {m} талонов. Сегодня осталось {k} из {t}",
  "CL-THERMOS-TEXT-NOPRICE": "Чай из термоса: +{n} энергии",
  "CL-THERMOS-DRINK": "Выпить за {s} {n, plural, one {талон} few {талона} many {талонов} other {талона}}",
  "CL-THERMOS-DRINK-ANYWAY": "Всё равно выпить за {s} {n, plural, one {талон} few {талона} many {талонов} other {талона}}",
  "CL-THERMOS-ENERGY": "энергии {v}",
  "CL-THERMOS-BURN": "Больше {cap} энергии не влезет: {n} сгорит",
  "CL-THERMOS-PLUS": "+{n} энергии",
  "CL-THERMOS-RESET": "Счёт термосов обнуляется в 04:00 МСК",
  "CL-PURCH-SPENDING": "Мои траты",
  "CL-PURCH-LIMIT": "Лимит трат в месяц",
  "CL-PURCH-WHAT": "История покупок",
  "CL-PURCH-OFFLINE": "Нет связи — история недоступна",
  "CL-PURCH-EMPTY": "Покупок пока не было",
  "CL-PURCH-ORDER": "Заказ",
  "CL-PURCH-CREDITED": "Начислено",
  "CL-PURCH-PENDING": "Ожидает начисления",
  "CL-PURCH-REFUNDED": "Возвращено",
  "CL-PURCH-CANCELLED": "Отменено",
  "CL-PURCH-NO-SELF-REFUND": "Вернуть звёзды можно через поддержку: открой заказ и нажми «Проблема с покупкой»",
  "CL-PURCH-PROBLEM": "Проблема с покупкой",
  "CL-PURCH-ORDER-NO": "Номер заказа",
  "CL-PURCH-COPY": "Копировать",
  "CL-PURCH-COPIED": "Скопировано",
  "CL-PURCH-CLAWBACK": "Списано при возврате: {s} {n, plural, one {талон} few {талона} many {талонов} other {талона}}",
  "CL-REFUND-TITLE": "Возврат звёзд",
  "CL-REFUND-TEXT": "Возврат по заказу {id}: звёзды вернулись на твой счёт Telegram.",
  "CL-REFUND-CLAWED": "Начисленное по заказу списано: {s} {n, plural, one {талон} few {талона} many {талонов} other {талона}}.",
  "CL-REFUND-DEBT": "Баланс талонов: −{s}. Пока есть долг, тратить талоны нельзя; новые покупки сначала закроют долг",
  "CL-REFUND-OK": "Понятно",
  "SHOP-DEBT": "Покупки за талоны — после погашения минуса",
  "SHOP-OFF": "Ларёк на переучёте до {time} МСК",
  "SHOP-OFFER-BADGE": "Для тебя",
  "SHOP-LOOK-NOTE": "Только для красоты. На силу не влияет.",
  "SHOP-SHOWCASE-TITLE": "Витрина председателя",
  "SHOP-SHOWCASE-HONEST": "Что видишь, то и берёшь. Шансов здесь нет",
  "SHOP-SHOWCASE-WEEK": "Куплено {k} из {limit} на этой неделе",
  "SHOP-SHOWCASE-BOUGHT": "Куплено ✓",
  "SHOP-THERMOS-LIMIT": "На сегодня всё — 5 термосов. Завтра после 04:00 МСК снова.",
  "CL-SHOWCASE-IN-DAYS": "через {d} дн {h} ч",
  "CL-SHOWCASE-IN-HOURS": "через {h} ч",
  "CL-SHOWCASE-CHANGED": "Витрина сменилась, пока окно было открыто. Вот новая — талоны не списаны",
  "CL-SHOWCASE-REFRESH": "Новая витрина в понедельник 04:00 МСК",
  "CL-SHOWCASE-LEVEL": "ур. {n}",
  "CL-SHOWCASE-ROLL": "Ролл 100% · +0",
  "CL-SHOWCASE-WORN": "Сейчас надето: {name}",
  "CL-SHOWCASE-TAKE": "Взять",
  "CL-SHOWCASE-NOTE": "После покупки место пустует до понедельника. Частей «Председателя» на витрине нет",
  "CL-SHOWCASE-ERR-WEEK": "На этой неделе уже две покупки. Снова в понедельник",
  "CL-BOX-IRON": "Железный ящик",
  "CL-BOX-UNCLE": "Посылка от дяди Вити",
  "CL-BOX-PASS": "Сезонная посылка",
  "CL-BOX-ANY": "Ящик",
  "CL-BOX-TROPHY": "трофей",
  "CL-BOX-CUT": "Связь оборвалась. Откроем снова — получишь то же",
  "CL-BOX-SAFE": "Ящик и ключи",
  "CL-BOX-NEED-KEY": "Нужен ключ",
  "CL-BOX-OPEN-ALL": "Открыть все ({n})",
  "CL-BOX-OPEN": "Открыть",
  "CL-BOX-SKIP": "Пропустить",
  "CL-BOX-HAVE": "Ящиков: {n}",
  "CL-BOX-KEYS": "ключей: {n}",
  "CL-BOX-OPENING": "Открываем…",
  "CL-ODDS-VERSION": "Таблица № {v}",
  "CL-ODDS-CACHED": "Нет связи. Данные на {d}",
  "CL-ODDS-ERR": "Шансы не загрузились",
  "CL-ODDS-TROPHIES": "Трофеи босса",
  "CL-ODDS-SUM": "Сумма строк не равна 100% — сообщи в поддержку",
  "CL-ODDS-FOOTER": "Шансы не зависят от покупок и времени",
  "ODDS-TITLE": "Шансы: {source}",
  "ODDS-INTRO": "Так выпадает на самом деле. Шансы одинаковы для всех.",
  "ODDS-COUNTER": "До гарантии: {g}",
  "CL-THERMOS-ROW": "{m} талонов · {k} из {n}",
  "CL-STORE-RUB-SHORT": "₽ — примерно, точная сумма в окне Telegram",
  "CL-STORE-LIMIT-WEEK-ONE": "Раз в неделю",
  // --- Предметы: сеты, жетоны S8, перенос, выкуп, сброс очков (фронтенд-2: E05-T07, T16, T18, T22) ---
  "CL-BEST-WEAR": "Надеть лучшее",
  "CL-BEST-NONE": "Лучше надетого ничего нет — с учётом переноса улучшения",
  "CL-BEST-DONE": "Надето лучшее: {n}",
  "UI-STATS-RESPEC": "Сбросить очки",
  "CL-RESPEC-FREE": "Бесплатно",
  "CL-RESPEC-PRICE-NUTS": "{n} гаек",
  "CL-RESPEC-TITLE": "Сбросить очки?",
  "CL-RESPEC-TEXT-FREE": "Все очки вернутся в свободные. Первый сброс в сезоне — бесплатно",
  "CL-RESPEC-TEXT": "Все очки вернутся в свободные. Цена — {n} гаек, следующий сброс будет дороже",
  "CL-RESPEC-GO-FREE": "Сбросить бесплатно",
  "CL-RESPEC-GO": "Сбросить за {n} гаек",
  "CL-RESPEC-KEEP": "Оставить как есть",
  "CL-RESPEC-DONE": "Очки вернулись: свободно {n}. Раздай заново или нажми «Раздать за меня»",
  "CL-RESPEC-PRICE": "Цена обновилась: {n} гаек. Нажми ещё раз",
  "CL-RESPEC-NUTS": "Не хватает гаек на сброс",
  "CL-RESPEC-WHERE": "Где взять",
  "CL-RESPEC-BATTLE": "Сначала доиграй заход",
  "CL-RESPEC-TOP10": "Сброс недоступен, пока ты в топ-10 рейда",
  "CL-RESPEC-NOTHING": "Сбрасывать пока нечего",
  "CL-RESPEC-SAFE": "Гайки",
  "CL-RESPEC-COUNT": "Сбросов в этом сезоне: {n}",
  "CL-SETS-TITLE": "Сеты",
  "CL-SETS-OFFLINE": "Нет связи — показаны сохранённые данные",
  "CL-SETS-COUNT": "{k}/{n}",
  "CL-SETS-FROM-LVL": "с {n} ур.",
  "CL-SETS-FULL": "Полный:",
  "CL-SETS-LACK": "надень ещё {n}",
  "CL-SETS-WORN-FULL": "Надето полностью",
  "CL-SETS-ALL-HAVE": "Все части у тебя",
  "CL-SETS-WEAR": "Надеть сет «{name}»",
  "CL-S8-TITLE": "Жетоны председателя",
  "CL-S8-COUNTER": "Жетоны председателя: {n} / {norm}",
  "CL-S8-HINT": "+1 за победу над боссом района (один на один)",
  "CL-S8-LOCKED": "Жетоны — с 30-го уровня",
  "CL-S8-EXCHANGE": "Обменять",
  "CL-S8-DONE": "Сет собран жетонами",
  "CL-S8-ERR": "Жетоны не загрузились",
  "CL-S8-READY": "Можно обменять жетоны",
  "CL-S8-HAVE": "уже есть",
  "CL-S8-MISSING": "нет в коллекции",
  "CL-S8-ROLL": "Ролл случайный, +0 — покажем после обмена",
  "CL-S8-EXCHANGES": "Обменов: {k} из {n}",
  "CL-S8-NEXT": "Следующий обмен — с понедельника {d}, 04:00",
  "CL-S8-WEEKLY": "Снова в понедельник 04:00",
  "CL-S8-LACK": "Не хватает {n} жетонов",
  "CL-S8-CTA": "Обменять {norm} жетонов на «{item}»",
  "CL-S8-ERR-TOKENS": "Жетонов не хватает",
  "CL-S8-SAFE": "Жетоны",
  "CL-SOLD-TAB": "Продано",
  "CL-SOLD-EMPTY": "За сутки ничего не продано",
  "CL-SOLD-HINT": "Проданное за 24 часа можно выкупить за ту же цену",
  "CL-SOLD-UNTIL": "выкуп до {t}",
  "CL-SOLD-BUY": "Выкупить · {s}",
  "CL-SOLD-BACK": "«{item}» снова в сумке",
  "CL-SOLD-GONE": "Срок выкупа прошёл",
  "CL-SOLD-ALREADY": "Уже выкуплено",
  "CL-SOLD-NUTS": "Не хватает гаек на выкуп",
  "CL-TRANSFER-TITLE": "Перенос улучшения",
  "CL-TRANSFER-OFFER": "Можно перенести +{n} с «{item}»",
  "CL-TRANSFER-OPEN": "Перенести улучшение",
  "CL-TRANSFER-RARITY": "Перенос только на деталь не ниже редкостью",
  "CL-TRANSFER-STEPS": "Перейдёт ступеней: {n}",
  "CL-TRANSFER-COST": "Цена: {s}",
  "CL-TRANSFER-LACK": "Не хватает {n} гаек",
  "CL-TRANSFER-MASTERY": "Мастерство {m} переносится тоже",
  "CL-TRANSFER-LOST": "{n} ступени сверх потолка пропадут",
  "CL-TRANSFER-DONOR-ZERO": "«{item}» станет +0; лом в ней останется — при разборе вернётся половина вложенного",
  "CL-TRANSFER-AUTO-EQUIP": "Новая деталь наденется сама, старая уйдёт в сумку",
  "CL-TRANSFER-CTA": "Перенести за {n} гаек",
  "CL-TRANSFER-STALE": "Деталь изменилась — пересчитали перенос",
  "CL-TRANSFER-NUTS": "Не хватает гаек — числа обновлены",
  "CL-TRANSFER-NOT-ALLOWED": "Так перенести нельзя: другой слот или редкость ниже",
  "CL-TRANSFER-ERR": "Перенос не посчитался",
  "CL-TRANSFER-GONE": "Детали уже нет в сумке",
  "CL-TRANSFER-SAFE": "Гайки и детали",
  "CL-SETS-MORE": "· подробнее",
  "CL-STORE-BOXES-OFF": "Не продаётся",
  "CL-STORE-BOXES-OFF-WHY": "Платные ящики сейчас выключены. Ящики можно получить в боях и заданиях",
  // --- Карта D1–D3 и кооперативные инстансы (фронтенд-2, E04-T07) ---
  "CL-MAP-FOG": "Дальше — скоро",
  "CL-MAP-LVLS": "ур. {r}",
  "CL-INST-BURNS": "сгорит через {t}",
  "CL-INST-BURNED": "время вышло",
  "CL-INST-COOP": "Кооператив бьёт: {boss}",
  "CL-INST-MODE": "Кооператив",
  "CL-INST-HP": "Общее HP: {hp} / {max}",
  "CL-INST-PARTICIPANTS": "бьют {n}",
  "CL-INST-MY": "Мой вклад: {n}",
  "CL-INST-QUALIFIED": "Порог вклада пройден — доля в котле твоя",
  "CL-INST-NOT-QUALIFIED": "До доли в котле — ещё немного урона",
  "CL-INST-NOT-ADMITTED": "Вступил меньше суток назад — награду получишь, если пробудешь в кооперативе 24 ч к концу",
  "CL-INST-RESULT-OPEN": "Итог",
  "CL-INST-WHAT": "Инстанс",
  "CL-INST-GO": "В общий бой · {n}",
  "CL-INST-SOLO": "Бить одному",
  "CL-INST-NOT-IN-COOP": "Ты больше не в кооперативе",
  "CL-INST-WON": "Побеждён",
  "CL-INST-GONE": "Ушёл",
  "CL-INST-REMOVED": "Снято {p}% общего HP",
  "CL-INST-RANK": "место {n}",
  "CL-INST-NO-REWARD": "Награды нет: босс ушёл целым — сняли только {p}%, а нужно хотя бы половину",
  "CL-INST-MAILED": "Начислено при подсчёте — письмо в почте",
  "CL-INST-NO-SHARE": "Без доли в котле: вклад ниже порога или не прошёл допуск",
  "CL-INST-NEW-FIGHT": "Новый бой · 10",
  "CL-INST-TABLE": "Таблица вклада",
  "CL-INST-TAKE": "Забрать",
  "CL-CALL-TITLE": "Вызвать босса",
  "CL-CALL-OPEN": "Вызвать босса кооперативу",
  "CL-CALL-SUMMONS": "Объявлений о сборе: {k} / {n}",
  "CL-CALL-NO-SUMMONS": "Нет объявления о сборе",
  "CL-CALL-NO-SUMMONS-WHY": "Объявления о сборе даёт Доска объявлений; копится не больше трёх",
  "CL-CALL-RULES": "Вызов тратит одно объявление о сборе. Босс живёт 24 часа, его HP зависит от числа участников",
  "CL-CALL-PICK": "Выбери босса",
  "CL-CALL-GO": "Вызвать: {boss}",
  "CL-CALL-ALREADY": "Уже вызван: {boss}",
  "CL-CALL-LOCKED": "Не открыт у тебя",
  "CL-CALL-TERM": "Срок — 24 ч",
  "CL-CALL-NEWBIE": "Вступившие меньше суток назад получат награду, только если пробудут в кооперативе 24 ч к концу инстанса",
  "CL-CALL-DONE": "Вызвали: {boss}. Кооператив получил сигнал",
  "CL-CALL-ERR-ACTIVE": "Уже вызван — кто-то из руководства успел раньше",
  "CL-CALL-ERR-ELIGIBLE": "Этого босса победили меньше пяти участников",
  "CL-CALL-ERR-LOCKED": "Этот босс у тебя ещё не открыт",
  "CL-CALL-ERR-ROLE": "Вызывают председатель и заместители",
  "CL-CALL-ERR-BUILD": "Не хватает очков стройки на вызов",
  "CL-INST-COUNTING": "Считаем итог — пара секунд",
  "CL-INST-LAST-HIT": "последний удар: {name}",
  "CL-INST-SHARE": "Твоя доля",
  "CL-INST-POT": "Шанс на деталь из котла: {p}%",
  "CL-INST-POT-WON": "выпала «{item}»",
  "CL-INST-POT-MISS": "в этот раз не выпала",
  "CL-CALL-WINNERS": "Победили {k} из {n}",
  "CL-CALL-HP": "HP {hp} · срок 24 ч",
  // --- Друзья, приглашение, уважение, «Ещё» (фронтенд-2, E10-T04) ---
  "CL-FRIENDS-TITLE": "Друзья",
  "CL-FRIENDS-INVITE": "Пригласить друга",
  "CL-FRIENDS-COUNT": "Друзей: {n} / {max}",
  "CL-FRIENDS-EMPTY": "Друзей пока нет. Позови своих — награда обоим, когда друг дойдёт до 3-го уровня",
  "CL-FRIENDS-OFFLINE": "Нет связи — показан сохранённый список",
  "CL-FRIENDS-REQUESTS": "Заявки в друзья",
  "CL-FRIENDS-ACCEPT": "Принять",
  "CL-FRIENDS-DECLINE": "Отклонить",
  "CL-FRIENDS-ACCEPTED": "Теперь вы друзья",
  "CL-FRIENDS-DECLINED": "Заявка отклонена",
  "CL-FRIENDS-LVL": "ур. {n}",
  "CL-FRIENDS-OUTGOING": "Мои заявки",
  "CL-FRIENDS-WAITS": "ждёт ответа · ещё {d} дн",
  "CL-FRIENDS-CANCEL": "Отозвать",
  "CL-FRIENDS-CANCELLED": "Заявка отозвана",
  "CL-FRIENDS-FULL": "Список друзей полон — {n} из {n}",
  "CL-FRIENDS-REQ-GONE": "Заявки больше нет",
  "CL-REF-TITLE": "Приглашённые мной",
  "CL-REF-LEFT": "наград в этом месяце ещё: {n}",
  "CL-REF-PLAYER": "Игрок {id}",
  "CL-REF-PROGRESS": "ур. {n} из 3",
  "CL-REF-WAIT": "Ждём 3-й уровень",
  "CL-REF-L3": "Получено",
  "CL-REF-L10": "Получено · «Наставник»",
  "CL-REF-NONE": "Без награды",
  "CL-REF-NEXT": "дальше — 10-й уровень",
  "CL-RESPECT-GIVEN": "Уважил сегодня ✓",
  "CL-RESPECT-DONE": "Уважение отправлено. Сегодня ещё: {n}",
  "CL-RESPECT-LIMIT": "На сегодня уважения кончились. Снова после 04:00",
  "CL-RESPECT-SELF": "Себя не уважишь — это другие",
  "CL-RESPECT-LOW": "Уважать можно игроков со 2-го уровня",
  "CL-RESPECT-GONE": "Игрока не нашли",
  "CL-INVITE-TITLE": "Позови своих",
  "CL-INVITE-BODY": "Награда — обоим, когда друг дойдёт до 3-го уровня",
  "CL-INVITE-SHARE": "Отправить в Telegram",
  "CL-INVITE-COPY": "Копировать ссылку",
  "CL-INVITE-COPIED": "Ссылка скопирована",
  "CL-INVITE-SENT": "Приглашение отправлено",
  "CL-INVITE-SHARE-TEXT": "Залетай в гаражи, тут Шушера проводку грызёт",
  "CL-INVITE-LINK": "Ссылка не загрузилась",
  "CL-INVITE-STATS": "Приглашено: {n}, получили награду: {k}",
  "CL-INVITE-NOTE": "Друг заходит по ссылке — и вы связаны навсегда",
  "CL-MORE-TITLE": "Ещё",
  "CL-MORE-STORY": "Журнал сюжета",
  "CL-MORE-RATINGS": "Рейтинги",
  "CL-MORE-MAIL": "Почта",
  "CL-MORE-PASS": "Пропуск",
  "CL-MORE-EVENTS": "События",
  "CL-MORE-SETTINGS": "Настройки",
  "CL-MORE-SUPPORT": "Поддержка",
  "CL-MORE-LEGAL": "Правила",
  "CL-MORE-FOOT": "Версия {v} · ID {id} (тап — копировать)",
  "CL-SYS-VERSION": "Твоя версия {v}",
  "CL-SYS-VERSION-NEED": "нужна {v}",
  "CL-BAN-ID": "Твой ID: {id} — назови его в поддержке",
  "CL-BAN-CHEATING": "Причина: нечестная игра",
  "CL-BAN-FRAUD": "Причина: мошенничество",
  "CL-BAN-PAYMENTS": "Причина: нарушения с оплатой",
  "CL-BAN-ABUSE": "Причина: оскорбления и травля",
  "CL-BAN-MULTIACC": "Причина: несколько аккаунтов",
  "CL-BAN-SPAM": "Причина: спам",
  "CL-BAN-OTHER": "Причина: нарушение правил игры",
  "CL-VISIT-FRIEND-SENT": "Заявка отправлена",
  "CL-VISIT-FRIENDS": "В друзьях ✓",
  "CL-VISIT-REPORTED": "Жалоба отправлена — модераторы посмотрят",
  "CL-VISIT-REPORT-LIMIT": "На сегодня жалоб хватит",
  "CL-VISIT-REPORT-WHAT": "На что жалуемся:",
  "CL-VISIT-REPORT-NAME": "На имя",
  "CL-VISIT-REPORT-GARAGE": "На гараж",
  "CL-FRIENDS-ONLINE": "в сети",
  "CL-FRIENDS-SEEN-MIN": "был {n} мин назад",
  "CL-FRIENDS-SEEN-H": "был {n} ч назад",
  "CL-FRIENDS-SEEN-D": "был {n} дн назад",
  "CL-REF-MONTH": "Награды за приглашения в этом месяце: {k} из {n}",
  "CL-INVITE-BODY-REWARD": "{reward} — обоим, когда друг дойдёт до 3-го уровня",
  "CL-AND": " и ",
  // --- Сила к боссу и подсказки баланса (фронтенд-2) ---
  "CL-POWER-PCT": "Сила {n}% от рекомендуемой",
  "CL-POWER-LOW": "Будет тяжело",
  "CL-POWER-OK": "Хватает",
  "CL-POWER-TIPS": "Как стать сильнее:",
  "CL-POWER-WEAR": "Надеть лучшее из сумки",
  "CL-POWER-UPGRADE": "Улучшить детали на Верстаке",
  "CL-POWER-POINTS": "Раздать свободные очки: {n}",
  "CL-POWER-STATS": "Перераспределить очки характеристик",
  "CL-POWER-CHA": "Очки в Харизме бой не усиливают — их можно сбросить и раздать в Силу и Живучесть",
  "CL-STATS-CHA-HINT": "Харизма в бою не помогает: она даёт скидки и бонусы вне боя. Для боя — Сила, Сноровка и Живучесть",
  // ---- Друзья: «Позвать друга» первой кнопкой (пункт «Позвать» колонки объединён с «Друзьями») ----
  "CL-FRIENDS-CALL": "Позвать друга",
  "CL-FRIENDS-CALL-REWARD": "{reward} — обоим за 3-й уровень друга",
  "CL-FRIENDS-CALL-MORE": "Ссылка и условия",
  // ---- Оплата: окно счёта закрыто без оплаты (отмена, ошибка, крестик у докупки звёзд) ----
  "CL-PAY-NOT-DONE": "Оплата не прошла. Не хватает звёзд? Пополни баланс в Telegram и попробуй снова",
  "CL-PAY-CANCEL": "Отменить",
  // ---- Требуемый уровень предмета (Р-107) ----
  "CL-ITEM-FROM-LVL": "с ур. {n}",
  "CL-ITEM-REQ": "Надеть можно с {n}-го уровня",
  "CL-ITEM-REQ-LOW": "Надеть можно с {n}-го уровня, у тебя {me}-й",
} as const satisfies Record<string, string>;
